export const SET_REQUEST_IN_PROCESS = 'SET_REQUEST_IN_PROCESS';
export const SET_REQUEST_PROGRESS = 'SET_REQUEST_PROGRESS';
export const SET_ERROR = 'SET_ERROR';
export const SET_LOCAL_ERROR = 'SET_LOCAL_ERROR';
export const CLEAR_ERROR = 'CLEAR_ERROR';
export const CLEAR_LOCAL_ERROR = 'CLEAR_LOCAL_ERROR';
export const CLEAR_ERROR_INIT = 'CLEAR_ERROR_INIT';
export const ADD_PROCESS = 'ADD_PROCESS';
export const REMOVE_PROCESS = 'REMOVE_PROCESS';

export const SET_SESSION = 'SET_SESSION';
export const RESET_SESSION = 'RESET_SESSION';

//pagination
export const WAIT_PAGINATED_RESPONSE = 'WAIT_PAGINATED_RESPONSE';
export const CLEAR_PAGINATED_RESPONSE = 'CLEAR_PAGINATED_RESPONSE';

//LocalStorage
export const HYDRATE_FROM_LOCAL_STORE = 'HYDRATE_FROM_LOCAL_STORE';

// Section Navigation
export const SAVE_SECTION_PATH = 'SAVE_SECTION_PATH';
export const CLEAR_SECTION_PATH = 'CLEAR_SECTION_PATH';

export const SET_APP_CURRENT_PATH = 'SET_APP_CURRENT_PATH';

// Public Marketplace Request
export const AWS_MKTPLACE_TOKEN_REQUEST = 'AWS_MKTPLACE_TOKEN_REQUEST';
export const AWS_MKTPLACE_TOKEN_SUCCESS = 'AWS_MKTPLACE_TOKEN_SUCCESS';
export const AWS_MKTPLACE_TOKEN_FAILURE = 'AWS_MKTPLACE_TOKEN_FAILURE';

//Google Authentication
export const SET_G_USER = 'SET_G_USER';

export const LOAD_GAPI = 'LOAD_GAPI';
export const LOAD_GAPI_SUCCESS = 'LOAD_GAPI_SUCCESS';
export const LOAD_GAPI_FAILURE = 'LOAD_GAPI_FAILURE';

export const GAPI_LOGIN_REQUEST = 'GAPI_LOGIN_REQUEST';
export const GAPI_LOGIN_SUCCESS = 'GAPI_LOGIN_SUCCESS';
export const GAPI_LOGIN_FAILURE = 'GAPI_LOGIN_FAILURE';

export const GAPI_SIGNUP_REQUEST = 'GAPI_SIGNUP_REQUEST';
export const GAPI_SIGNUP_SUCCESS = 'GAPI_SIGNUP_SUCCESS';
export const GAPI_SIGNUP_FAILURE = 'GAPI_SIGNUP_FAILURE';

export const GAPI_LOGOUT_REQUEST = 'GAPI_LOGOUT_REQUEST';
export const GAPI_LOGOUT_SUCCESS = 'GAPI_LOGOUT_SUCCESS';
export const GAPI_LOGOUT_FAILURE = 'GAPI_LOGOUT_FAILURE';

export const GAPI_GD_OFFLINE_REQUEST = 'GAPI_GD_OFFLINE_REQUEST';
export const GAPI_GD_OFFLINE_SUCCESS = 'GAPI_GD_OFFLINE_SUCCESS';
export const GAPI_GD_OFFLINE_FAILURE = 'GAPI_GD_OFFLINE_FAILURE';

//Nexla Authentication
export const SET_NEX_USER = 'SET_NEX_USER';
export const SET_NEX_USER_TOKEN = 'SET_NEX_USER_TOKEN';
export const SET_NEX_USER_ORG = 'SET_NEX_USER_ORG';

export const NEX_GTOKEN_AUTH_REQUEST = 'NEX_GTOKEN_AUTH_REQUEST';
export const NEX_GTOKEN_AUTH_SUCCESS = 'NEX_GTOKEN_AUTH_SUCCESS';
export const NEX_GTOKEN_AUTH_FAILURE = 'NEX_GTOKEN_AUTH_FAILURE';

export const SESSION_HISTORY_REQUEST = 'SESSION_HISTORY_REQUEST';
export const SESSION_HISTORY_SUCCESS = 'SESSION_HISTORY_SUCCESS';
export const SESSION_HISTORY_FAILURE = 'SESSION_HISTORY_FAILURE';

export const NEX_USERNAME_AUTH_REQUEST = 'NEX_USERNAME_AUTH_REQUEST';
export const NEX_USERNAME_AUTH_SUCCESS = 'NEX_USERNAME_AUTH_SUCCESS';
export const NEX_USERNAME_AUTH_FAILURE = 'NEX_USERNAME_AUTH_FAILURE';

export const CLEAR_SESSION_ERROR = 'CLEAR_SESSION_ERROR';

export const NEX_SIGNUP_REQUEST = 'NEX_SIGNUP_REQUEST';
export const NEX_SIGNUP_SUCCESS = 'NEX_SIGNUP_SUCCESS';
export const NEX_SIGNUP_FAILURE = 'NEX_SIGNUP_FAILURE';

export const NEX_VERIFY_EMAIL_REQUEST = 'NEX_VERIFY_EMAIL_REQUEST';
export const NEX_VERIFY_EMAIL_SUCCESS = 'NEX_VERIFY_EMAIL_SUCCESS';
export const NEX_VERIFY_EMAIL_FAILURE = 'NEX_VERIFY_EMAIL_FAILURE';

export const NEX_LOGOUT_REQUEST = 'NEX_LOGOUT_REQUEST';
export const NEX_LOGOUT_SUCCESS = 'NEX_LOGOUT_SUCCESS';
export const NEX_LOGOUT_FAILURE = 'NEX_LOGOUT_FAILURE';

export const NEX_REFRESH_AUTH_REQUEST = 'NEX_REFRESH_AUTH_REQUEST';
export const NEX_REFRESH_AUTH_SUCCESS = 'NEX_REFRESH_AUTH_SUCCESS';
export const NEX_REFRESH_AUTH_FAILURE = 'NEX_REFRESH_AUTH_FAILURE';

export const NEX_EXTERNAL_TOKEN_AUTH_REQUEST = 'NEX_EXTERNAL_TOKEN_AUTH_REQUEST';
export const NEX_EXTERNAL_TOKEN_AUTH_SUCCESS = 'NEX_EXTERNAL_TOKEN_AUTH_SUCCESS';
export const NEX_EXTERNAL_TOKEN_AUTH_FAILURE = 'NEX_EXTERNAL_TOKEN_AUTH_FAILURE';

export const LOGOUT_COMPLETE = 'LOGOUT_COMPLETE';

//Reset Password
export const RESET_PASSWORD_FORM_LOADED = 'RESET_PASSWORD_FORM_LOADED';
export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE';

export const SET_PASSWORD_FORM_LOADED = 'SET_PASSWORD_FORM_LOADED';
export const SET_PASSWORD_REQUEST = 'SET_PASSWORD_REQUEST';
export const SET_PASSWORD_SUCCESS = 'SET_PASSWORD_SUCCESS';
export const SET_PASSWORD_FAILURE = 'SET_PASSWORD_FAILURE';

export const SSO_AUTH_WAITING_FOR_AUTH = 'SSO_AUTH_WAITING_FOR_AUTH';

export const SSO_IDP_AUTH_START = 'SSO_IDP_AUTH_START';
export const SSO_IDP_AUTH_RECEIVE_CODE = 'SSO_IDP_AUTH_RECEIVE_CODE';
export const SSO_IDP_AUTH_RECEIVE_TOKEN = 'SSO_IDP_AUTH_RECEIVE_TOKEN';

export const NEX_SSO_AUTH_LOGIN_REQUEST = 'NEX_SSO_AUTH_LOGIN_REQUEST';
export const NEX_SSO_AUTH_LOGIN_SUCCESS = 'NEX_SSO_AUTH_LOGIN_SUCCESS';
export const NEX_SSO_AUTH_LOGIN_FAILURE = 'NEX_SSO_AUTH_LOGIN_FAILURE';

//Impersonation
export const IMPERSONATION_REQUEST = 'IMPERSONATION_REQUEST';
export const IMPERSONATION_SUCCESS = 'IMPERSONATION_SUCCESS';
export const IMPERSONATION_FAILURE = 'IMPERSONATION_FAILURE';

export const END_IMPERSONATION = 'END_IMPERSONATION';

//Users
export const GET_USERS_REQUEST = 'GET_USERS_REQUEST';
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';
export const GET_USERS_FAILURE = 'GET_USERS_FAILURE';

export const GET_USER_REQUEST = 'GET_USER_REQUEST';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const GET_USER_FAILURE = 'GET_USER_FAILURE';

export const DELETE_USER_REQUEST = 'DELETE_USER_REQUEST';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DELETE_USER_FAILURE = 'DELETE_USER_FAILURE';

export const UPDATE_USER_INFO_REQUEST = 'UPDATE_USER_INFO_REQUEST';
export const UPDATE_USER_INFO_SUCCESS = 'UPDATE_USER_INFO_SUCCESS';
export const UPDATE_USER_INFO_FAILURE = 'UPDATE_USER_INFO_FAILURE';

export const USER_ACCEPT_TOS_REQUEST = 'USER_ACCEPT_TOS_REQUEST';
export const USER_ACCEPT_TOS_SUCCESS = 'USER_ACCEPT_TOS_SUCCESS';
export const USER_ACCEPT_TOS_FAILURE = 'USER_ACCEPT_TOS_FAILURE';

export const DEACTIVATE_USER_REQUEST = 'DEACTIVATE_USER_REQUEST';
export const DEACTIVATE_USER_SUCCESS = 'DEACTIVATE_USER_SUCCESS';
export const DEACTIVATE_USER_FAILURE = 'DEACTIVATE_USER_FAILURE';

export const GET_USER_SETTINGS_REQUEST = 'GET_USER_SETTINGS_REQUEST';
export const GET_USER_SETTINGS_SUCCESS = 'GET_USER_SETTINGS_SUCCESS';
export const GET_USER_SETTINGS_FAILURE = 'GET_USER_SETTINGS_REQUEST';

export const CREATE_USER_SETTINGS_REQUEST = 'CREATE_USER_SETTINGS_REQUEST';
export const CREATE_USER_SETTINGS_SUCCESS = 'CREATE_USER_SETTINGS_SUCCESS';
export const CREATE_USER_SETTINGS_FAILURE = 'CREATE_USER_SETTINGS_FAILURE';

export const UPDATE_USER_SETTINGS_REQUEST = 'UPDATE_USER_SETTINGS_REQUEST';
export const UPDATE_USER_SETTINGS_SUCCESS = 'UPDATE_USER_SETTINGS_SUCCESS';
export const UPDATE_USER_SETTINGS_FAILURE = 'UPDATE_USER_SETTINGS_FAILURE';

export const ACTIVATE_USER_REQUEST = 'ACTIVATE_USER_REQUEST';
export const ACTIVATE_USER_SUCCESS = 'ACTIVATE_USER_SUCCESS';
export const ACTIVATE_USER_FAILURE = 'ACTIVATE_USER_FAILURE';

//Teams
export const GET_TEAMS_REQUEST = 'GET_TEAMS_REQUEST';
export const GET_TEAMS_SUCCESS = 'GET_TEAMS_SUCCESS';
export const GET_TEAMS_FAILURE = 'GET_TEAMS_FAILURE';

export const GET_TEAM_REQUEST = 'GET_TEAM_REQUEST';
export const GET_TEAM_SUCCESS = 'GET_TEAM_SUCCESS';
export const GET_TEAM_FAILURE = 'GET_TEAM_FAILURE';

export const GET_MY_TEAMS_REQUEST = 'GET_MY_TEAMS_REQUEST';
export const GET_MY_TEAMS_SUCCESS = 'GET_MY_TEAMS_SUCCESS';
export const GET_MY_TEAMS_FAILURE = 'GET_MY_TEAMS_FAILURE';

export const ADD_TEAM_REQUEST = 'ADD_TEAM_REQUEST';
export const ADD_TEAM_SUCCESS = 'ADD_TEAM_SUCCESS';
export const ADD_TEAM_FAILURE = 'ADD_TEAM_FAILURE';

export const UPDATE_TEAM_INFO_REQUEST = 'UPDATE_TEAM_INFO_REQUEST';
export const UPDATE_TEAM_INFO_SUCCESS = 'UPDATE_TEAM_INFO_SUCCESS';
export const UPDATE_TEAM_INFO_FAILURE = 'UPDATE_TEAM_INFO_FAILURE';

export const UPDATE_TEAM_MEMBERS_REQUEST = 'UPDATE_TEAM_MEMBERS_REQUEST';
export const UPDATE_TEAM_MEMBERS_SUCCESS = 'UPDATE_TEAM_MEMBERS_SUCCESS';
export const UPDATE_TEAM_MEMBERS_FAILURE = 'UPDATE_TEAM_MEMBERS_FAILURE';

// Quarantine / Errors
export const GET_QUARANTINE_REQUEST = 'GET_QUARANTINE_REQUEST';
export const GET_QUARANTINE_SUCCESS = 'GET_QUARANTINE_SUCCESS';
export const GET_QUARANTINE_FAILURE = 'GET_QUARANTINE_FAILURE';

export const SAVE_QUARANTINE_REQUEST = 'SAVE_QUARANTINE_REQUEST';
export const SAVE_QUARANTINE_SUCCESS = 'SAVE_QUARANTINE_SUCCESS';
export const SAVE_QUARANTINE_FAILURE = 'SAVE_QUARANTINE_FAILURE';

export const DELETE_QUARANTINE_REQUEST = 'DELETE_QUARANTINE_REQUEST';
export const DELETE_QUARANTINE_SUCCESS = 'DELETE_QUARANTINE_SUCCESS';
export const DELETE_QUARANTINE_FAILURE = 'DELETE_QUARANTINE_FAILURE';

export const CLEAR_NEW_CRED_FOR_QUARANTINE = 'CLEAR_NEW_CRED_FOR_QUARANTINE';

export const GET_RESOURCE_QUARANTINE_FILES_REQUEST = 'GET_RESOURCE_QUARANTINE_FILES_REQUEST';
export const GET_RESOURCE_QUARANTINE_FILES_SUCCESS = 'GET_RESOURCE_QUARANTINE_FILES_SUCCESS';
export const GET_RESOURCE_QUARANTINE_FILES_FAILURE = 'GET_RESOURCE_QUARANTINE_FILES_FAILURE';

export const GET_RESOURCE_QUARANTINE_SAMPLES_REQUEST = 'GET_RESOURCE_QUARANTINE_SAMPLES_REQUEST';
export const GET_RESOURCE_QUARANTINE_SAMPLES_SUCCESS = 'GET_RESOURCE_QUARANTINE_SAMPLES_SUCCESS';
export const GET_RESOURCE_QUARANTINE_SAMPLES_FAILURE = 'GET_RESOURCE_QUARANTINE_SAMPLES_FAILURE';

export const GET_DASHBOARD_METRICS_REQUEST = 'GET_DASHBOARD_METRICS_REQUEST';
export const GET_DASHBOARD_METRICS_SUCCESS = 'GET_DASHBOARD_METRICS_SUCCESS';
export const GET_DASHBOARD_METRICS_FAILURE = 'GET_DASHBOARD_METRICS_FAILURE';

export const START_EDIT_USER = 'START_EDIT_USER';
export const CANCEL_EDIT_USER = 'CANCEL_EDIT_USER';
export const UPDATE_EDIT_USER = 'UPDATE_EDIT_USER';

//Orgs
export const GET_ALL_ORGS_REQUEST = 'GET_ALL_ORGS_REQUEST';
export const GET_ALL_ORGS_SUCCESS = 'GET_ALL_ORGS_SUCCESS';
export const GET_ALL_ORGS_FAILURE = 'GET_ALL_ORGS_FAILURE';

export const GET_ORG_REQUEST = 'GET_ORG_REQUEST';
export const GET_ORG_SUCCESS = 'GET_ORG_SUCCESS';
export const GET_ORG_FAILURE = 'GET_ORG_FAILURE';

export const UPDATE_ORG_INFO_REQUEST = 'UPDATE_ORG_INFO_REQUEST';
export const UPDATE_ORG_INFO_SUCCESS = 'UPDATE_ORG_INFO_SUCCESS';
export const UPDATE_ORG_INFO_FAILURE = 'UPDATE_ORG_INFO_FAILURE';

export const UPDATE_ORG_MEMBER_REQUEST = 'UPDATE_ORG_MEMBER_REQUEST';
export const UPDATE_ORG_MEMBER_SUCCESS = 'UPDATE_ORG_MEMBER_SUCCESS';
export const UPDATE_ORG_MEMBER_FAILURE = 'UPDATE_ORG_MEMBER_FAILURE';

export const START_EDIT_ORG = 'START_EDIT_ORG';
export const CANCEL_EDIT_ORG = 'CANCEL_EDIT_ORG';
export const UPDATE_EDIT_ORG = 'UPDATE_EDIT_ORG';

export const GET_ORG_MEMBERS_REQUEST = 'GET_ORG_MEMBERS_REQUEST';
export const GET_ORG_MEMBERS_SUCCESS = 'GET_ORG_MEMBERS_SUCCESS';
export const GET_ORG_MEMBERS_FAILURE = 'GET_ORG_MEMBERS_FAILURE';

export const ADD_ORG_MEMBERS_REQUEST = 'ADD_ORG_MEMBERS_REQUEST';
export const ADD_ORG_MEMBERS_SUCCESS = 'ADD_ORG_MEMBERS_SUCCESS';
export const ADD_ORG_MEMBERS_FAILURE = 'ADD_ORG_MEMBERS_FAILURE';

export const GET_ORG_CUSTODIANS_REQUEST = 'GET_ORG_CUSTODIANS_REQUEST';
export const GET_ORG_CUSTODIANS_SUCCESS = 'GET_ORG_CUSTODIANS_SUCCESS';
export const GET_ORG_CUSTODIANS_FAILURE = 'GET_ORG_CUSTODIANS_FAILURE';

export const ADD_ORG_CUSTODIAN_REQUEST = 'ADD_ORG_CUSTODIAN_REQUEST';
export const ADD_ORG_CUSTODIAN_SUCCESS = 'ADD_ORG_CUSTODIAN_SUCCESS';
export const ADD_ORG_CUSTODIAN_FAILURE = 'ADD_ORG_CUSTODIAN_FAILURE';

export const DELETE_ORG_CUSTODIAN_REQUEST = 'DELETE_ORG_CUSTODIAN_REQUEST';
export const DELETE_ORG_CUSTODIAN_SUCCESS = 'DELETE_ORG_CUSTODIAN_SUCCESS';
export const DELETE_ORG_CUSTODIAN_FAILURE = 'DELETE_ORG_CUSTODIAN_FAILURE';

//Paging Signal
export const PAGING_SIGNAL_REQUEST = 'PAGING_SIGNAL_REQUEST';
export const PAGING_SIGNAL_SUCCESS = 'PAGING_SIGNAL_SUCCESS';
export const PAGING_SIGNAL_FAILURE = 'PAGING_SIGNAL_FAILURE';

//Common Connectors
export const GET_COMMON_CONNECTORS_REQUEST = 'GET_COMMON_CONNECTORS_REQUEST';
export const GET_COMMON_CONNECTORS_SUCCESS = 'GET_COMMON_CONNECTORS_SUCCESS';
export const GET_COMMON_CONNECTORS_FAILURE = 'GET_COMMON_CONNECTORS_FAILURE';
export const SET_COMMON_CONNECTORS_SUCCESS = 'SET_COMMON_CONNECTORS_SUCCESS';
export const SET_COMMON_CONNECTORS_FAILURE = 'SET_COMMON_CONNECTORS_FAILURE';

//Data Sources
export const GET_DATA_SOURCES_REQUEST = 'GET_DATA_SOURCES_REQUEST';
export const GET_DATA_SOURCES_SUCCESS = 'GET_DATA_SOURCES_SUCCESS';
export const GET_DATA_SOURCES_FAILURE = 'GET_DATA_SOURCES_FAILURE';

export const GET_DATA_SOURCE_REQUEST = 'GET_DATA_SOURCE_REQUEST';
export const GET_DATA_SOURCE_SUCCESS = 'GET_DATA_SOURCE_SUCCESS';
export const GET_DATA_SOURCE_FAILURE = 'GET_DATA_SOURCE_FAILURE';

export const SEARCH_DATA_SOURCES_REQUEST = 'SEARCH_DATA_SOURCES_REQUEST';
export const SEARCH_DATA_SOURCES_SUCCESS = 'SEARCH_DATA_SOURCES_SUCCESS';
export const SEARCH_DATA_SOURCES_FAILURE = 'SEARCH_DATA_SOURCES_FAILURE';

export const ADD_DATA_SOURCE_REQUEST = 'ADD_SOURCE_REQUEST';
export const ADD_DATA_SOURCE_SUCCESS = 'ADD_DATA_SOURCE_SUCCESS';
export const ADD_DATA_SOURCE_FAILURE = 'ADD_DATA_SOURCE_FAILURE';

export const ADD_TRIGGERS_TO_DATA_SOURCE_REQUEST = 'ADD_TRIGGERS_TO_DATA_SOURCE_REQUEST';
export const ADD_TRIGGERS_TO_DATA_SOURCE_SUCCESS = 'ADD_TRIGGERS_TO_DATA_SOURCE_SUCCESS';
export const ADD_TRIGGERS_TO_DATA_SOURCE_FAILURE = 'ADD_TRIGGERS_TO_DATA_SOURCE_FAILURE';

export const COPY_DATA_SOURCE_REQUEST = 'COPY_DATA_SOURCE_REQUEST';
export const COPY_DATA_SOURCE_SUCCESS = 'COPY_DATA_SOURCE_SUCCESS';
export const COPY_DATA_SOURCE_FAILURE = 'COPY_DATA_SOURCE_FAILURE';

export const ACTIVATE_SOURCE_REQUEST = 'ACTIVATE_SOURCE_REQUEST';
export const PAUSE_SOURCE_REQUEST = 'PAUSE_SOURCE_REQUEST';
export const RUN_SOURCE_NOW_REQUEST = 'RUN_SOURCE_NOW_REQUEST';
export const RUN_SOURCE_NOW_SUCCESS = 'RUN_SOURCE_NOW_SUCCESS';
export const RUN_SOURCE_NOW_FAILURE = 'RUN_SOURCE_NOW_FAILURE';
export const UPDATE_SOURCE_CONFIG_REQUEST = 'UPDATE_SOURCE_CONFIG_REQUEST';
export const UPDATE_SOURCE_INFO_REQUEST = 'UPDATE_SOURCE_INFO_REQUEST';
export const UPDATE_SOURCE_INFO_SUCCESS = 'UPDATE_SOURCE_INFO_SUCCESS';
export const UPDATE_SOURCE_INFO_FAILURE = 'UPDATE_SOURCE_INFO_FAILURE';

export const OVERRIDE_RUNTIME_STATUS = 'OVERRIDE_RUNTIME_STATUS';

export const FILE_REINGESTION_REQUEST = 'FILE_REINGESTION_REQUEST';
export const FILE_REINGESTION_SUCCESS = 'FILE_REINGESTION_SUCCESS';
export const FILE_REINGESTION_FAILURE = 'FILE_REINGESTION_FAILURE';

export const UPLOAD_FILE_TO_SOURCE_REQUEST = 'UPLOAD_FILE_TO_SOURCE_REQUEST';
export const UPLOAD_FILE_TO_SOURCE_SUCCESS = 'UPLOAD_FILE_TO_SOURCE_SUCCESS';
export const UPLOAD_FILE_TO_SOURCE_FAILURE = 'UPLOAD_FILE_TO_SOURCE_FAILURE';

export const DELETE_SOURCE_REQUEST = 'DELETE_SOURCE_REQUEST';
export const DELETE_SOURCE_SUCCESS = 'DELETE_SOURCE_SUCCESS';
export const DELETE_SOURCE_FAILURE = 'DELETE_SOURCE_FAILURE';

//Data Sets
export const GET_DATA_SETS_REQUEST = 'GET_DATA_SETS_REQUEST';
export const GET_DATA_SETS_SUCCESS = 'GET_DATA_SETS_SUCCESS';
export const GET_DATA_SETS_FAILURE = 'GET_DATA_SETS_FAILURE';

export const UPDATE_DATASET_REQUEST = 'UPDATE_DATASET_REQUEST';
export const UPDATE_DATASET_SUCCESS = 'UPDATE_DATASET_SUCCESS';
export const UPDATE_DATASET_FAILURE = 'UPDATE_DATASET_FAILURE';

export const GET_DATA_SETS_SUMMARY_REQUEST = 'GET_DATA_SETS_SUMMARY_REQUEST';
export const GET_DATA_SETS_SUMMARY_SUCCESS = 'GET_DATA_SETS_SUMMARY_SUCCESS';
export const GET_DATA_SETS_SUMMARY_FAILURE = 'GET_DATA_SETS_SUMMARY_FAILURE';

export const GET_DATA_SET_REQUEST = 'GET_DATA_SET_REQUEST';
export const GET_DATA_SET_SUCCESS = 'GET_DATA_SET_SUCCESS';
export const GET_DATA_SET_FAILURE = 'GET_DATA_SET_FAILURE';

export const GET_DATA_SET_FOR_ROUTING_REQUEST = 'GET_DATA_SET_FOR_ROUTING_REQUEST';
export const GET_DATA_SET_FOR_ROUTING_SUCCESS = 'GET_DATA_SET_FOR_ROUTING_SUCCESS';
export const GET_DATA_SET_FOR_ROUTING_FAILURE = 'GET_DATA_SET_FOR_ROUTING_FAILURE';

export const GET_DATA_SET_SUMMARY_REQUEST = 'GET_DATA_SET_SUMMARY_REQUEST';
export const GET_DATA_SET_SUMMARY_SUCCESS = 'GET_DATA_SET_SUMMARY_SUCCESS';
export const GET_DATA_SET_SUMMARY_FAILURE = 'GET_DATA_SET_SUMMARY_FAILURE';

export const GET_DATA_SET_DOC_REQUEST = 'GET_DATA_SET_DOC_REQUEST';
export const GET_DATA_SET_DOC_SUCCESS = 'GET_DATA_SET_DOC_SUCCESS';
export const GET_DATA_SET_DOC_FAILURE = 'GET_DATA_SET_DOC_FAILURE';

export const SEARCH_DATA_SETS_REQUEST = 'SEARCH_DATA_SETS_REQUEST';
export const SEARCH_DATA_SETS_SUCCESS = 'SEARCH_DATA_SETS_SUCCESS';
export const SEARCH_DATA_SETS_FAILURE = 'SEARCH_DATA_SETS_FAILURE';

export const UPDATE_DATA_SET_INFO_REQUEST = 'UPDATE_DATA_SET_INFO_REQUEST';
export const UPDATE_DATA_SET_INFO_SUCCESS = 'UPDATE_DATA_SET_INFO_SUCCESS';
export const UPDATE_DATA_SET_INFO_FAILURE = 'UPDATE_DATA_SET_INFO_FAILURE';

export const UPDATE_DATA_SET_RECIPE_REQUEST = 'UPDATE_DATA_SET_RECIPE_REQUEST';
export const UPDATE_DATA_SET_RECIPE_SUCCESS = 'UPDATE_DATA_SET_RECIPE_SUCCESS';
export const UPDATE_DATA_SET_RECIPE_FAILURE = 'UPDATE_DATA_SET_RECIPE_FAILURE';

export const UPDATE_SCHEMA_ANNOTATIONS_REQUEST = 'UPDATE_SCHEMA_ANNOTATIONS_REQUEST';
export const UPDATE_SCHEMA_ANNOTATIONS_SUCCESS = 'UPDATE_SCHEMA_ANNOTATIONS_SUCCESS';
export const UPDATE_SCHEMA_ANNOTATIONS_FAILURE = 'UPDATE_SCHEMA_ANNOTATIONS_FAILURE';

export const UPDATE_DATA_SET_DOC_REQUEST = 'UPDATE_DATA_SET_DOC_REQUEST';
export const UPDATE_DATA_SET_DOC_SUCCESS = 'UPDATE_DATA_SET_DOC_SUCCESS';
export const UPDATE_DATA_SET_DOC_FAILURE = 'UPDATE_DATA_SET_DOC_FAILURE';

export const DELETE_DATASET_REQUEST = 'DELETE_DATASET_REQUEST';
export const DELETE_DATASET_SUCCESS = 'DELETE_DATASET_SUCCESS';
export const DELETE_DATASET_FAILURE = 'DELETE_DATASET_FAILURE';

export const COPY_DATA_SET_TO_CLIPBOARD = 'COPY_DATA_SET_TO_CLIPBOARD';

//Data Sets samples
export const GET_DATA_SAMPLES_REQUEST = 'GET_DATA_SAMPLES_REQUEST';
export const GET_DATA_SAMPLES_SUCCESS = 'GET_DATA_SAMPLES_SUCCESS';
export const GET_DATA_SAMPLES_FAILURE = 'GET_DATA_SAMPLES_FAILURE';

export const UPDATE_DATA_SAMPLES_REQUEST = 'UPDATE_DATA_SAMPLES_REQUEST';
export const UPDATE_DATA_SAMPLES_SUCCESS = 'UPDATE_DATA_SAMPLES_SUCCESS';
export const UPDATE_DATA_SAMPLES_FAILURE = 'UPDATE_DATA_SAMPLES_FAILURE';

export const GET_DATA_CHARACTERISTICS_REQUEST = 'GET_DATA_CHARACTERISTICS_REQUEST';
export const GET_DATA_CHARACTERISTICS_SUCCESS = 'GET_DATA_CHARACTERISTICS_SUCCESS';
export const GET_DATA_CHARACTERISTICS_FAILURE = 'GET_DATA_CHARACTERISTICS_FAILURE';

export const GET_DATA_SET_UPDATE_TIME_REQUEST = 'GET_DATA_SET_UPDATE_TIME_REQUEST';
export const GET_DATA_SET_UPDATE_TIME_SUCCESS = 'GET_DATA_SET_UPDATE_TIME_SUCCESS';
export const GET_DATA_SET_UPDATE_TIME_FAILURE = 'GET_DATA_SET_UPDATE_TIME_FAILURE';

export const GET_TRANSFORMED_SAMPLES_REQUEST = 'GET_TRANSFORMED_SAMPLES_REQUEST';
export const GET_TRANSFORMED_SAMPLES_SUCCESS = 'GET_TRANSFORMED_SAMPLES_SUCCESS';
export const GET_TRANSFORMED_SAMPLES_FAILURE = 'GET_TRANSFORMED_SAMPLES_FAILURE';

export const GET_TRANSFORMED_SAMPLES_FROM_FLAT_TO_NEST_REQUEST =
  'GET_TRANSFORMED_SAMPLES_FROM_FLAT_TO_NEST_REQUEST';
export const GET_TRANSFORMED_SAMPLES_FROM_FLAT_TO_NEST_SUCCESS =
  'GET_TRANSFORMED_SAMPLES_FROM_FLAT_TO_NEST_SUCCESS';
export const GET_TRANSFORMED_SAMPLES_FROM_FLAT_TO_NEST_FAILURE =
  'GET_TRANSFORMED_SAMPLES_FROM_FLAT_TO_NEST_FAILURE';

//Derived Data Sets
export const ACTIVATE_DATASET_REQUEST = 'ACTIVATE_DATASET_REQUEST';
export const PAUSE_DATASET_REQUEST = 'PAUSE_DATASET_REQUEST';
export const UPDATE_DATASET_INFO_REQUEST = 'UPDATE_DATASET_INFO_REQUEST';
export const UPDATE_DATASET_INFO_SUCCESS = 'UPDATE_DATASET_INFO_SUCCESS';
export const UPDATE_DATASET_INFO_FAILURE = 'UPDATE_DATASET_INFO_FAILURE';

export const REGISTER_DATASET_ON_CATALOG_REQUEST = 'REGISTER_DATASET_ON_CATALOG_REQUEST';
export const REGISTER_DATASET_ON_CATALOG_SUCCESS = 'REGISTER_DATASET_ON_CATALOG_SUCCESS';
export const REGISTER_DATASET_ON_CATALOG_FAILURE = 'REGISTER_DATASET_ON_CATALOG_FAILURE';

export const ADD_DATASET_REQUEST = 'ADD_DATASET_REQUEST';
export const ADD_DATASET_SUCCESS = 'ADD_DATASET_SUCCESS';
export const ADD_DATASET_FAILURE = 'ADD_DATASET_FAILURE';

export const COPY_DATA_SET_REQUEST = 'COPY_DATA_SET_REQUEST';
export const COPY_DATA_SET_SUCCESS = 'COPY_DATA_SET_SUCCESS';
export const COPY_DATA_SET_FAILURE = 'COPY_DATA_SET_FAILURE';

export const SHARE_DATASET_REQUEST = 'SHARE_DATASET_REQUEST';
export const SHARE_DATASET_SUCCESS = 'SHARE_DATASET_SUCCESS';
export const SHARE_DATASET_FAILURE = 'SHARE_DATASET_FAILURE';

export const UNSHARE_DATASET_REQUEST = 'UNSHARE_DATASET_REQUEST';
export const UNSHARE_DATASET_SUCCESS = 'UNSHARE_DATASET_SUCCESS';
export const UNSHARE_DATASET_FAILURE = 'UNSHARE_DATASET_FAILURE';

export const REPLACE_SUBSCRIBERS_DATASET_REQUEST = 'REPLACE_SUBSCRIBERS_DATASET_REQUEST';
export const REPLACE_SUBSCRIBERS_DATASET_SUCCESS = 'REPLACE_SUBSCRIBERS_DATASET_SUCCESS';
export const REPLACE_SUBSCRIBERS_DATASET_FAILURE = 'REPLACE_SUBSCRIBERS_DATASET_FAILURE';

export const TEST_DATASET_REQUEST = 'TEST_DATASET_REQUEST';
export const TEST_DATASET_SUCCESS = 'TEST_DATASET_SUCCESS';
export const TEST_DATASET_FAILURE = 'TEST_DATASET_FAILURE';

//Available Nexsets (shared with me)

export const GET_AVAILABLE_DATASETS_REQUEST = 'GET_AVAILABLE_DATASETS_REQUEST';
export const GET_AVAILABLE_DATASETS_SUCCESS = 'GET_AVAILABLE_DATASETS_SUCCESS';
export const GET_AVAILABLE_DATASETS_FAILURE = 'GET_AVAILABLE_DATASETS_FAILURE';

export const SEARCH_AVAILABLE_DATASETS_REQUEST = 'SEARCH_AVAILABLE_DATASETS_REQUEST';
export const SEARCH_AVAILABLE_DATASETS_SUCCESS = 'SEARCH_AVAILABLE_DATASETS_SUCCESS';
export const SEARCH_AVAILABLE_DATASETS_FAILURE = 'SEARCH_AVAILABLE_DATASETS_FAILURE';

export const GET_AVAILABLE_DATASETS_SUMMARY_REQUEST = 'GET_AVAILABLE_DATASETS_SUMMARY_REQUEST';
export const GET_AVAILABLE_DATASETS_SUMMARY_SUCCESS = 'GET_AVAILABLE_DATASETS_SUMMARY_SUCCESS';
export const GET_AVAILABLE_DATASETS_SUMMARY_FAILURE = 'GET_AVAILABLE_DATASETS_SUMMARY_FAILURE';

export const GET_AVAILABLE_DATASET_REQUEST = 'GET_AVAILABLE_DATASET_REQUEST';
export const GET_AVAILABLE_DATASET_SUCCESS = 'GET_AVAILABLE_DATASET_SUCCESS';
export const GET_AVAILABLE_DATASET_FAILURE = 'GET_AVAILABLE_DATASET_FAILURE';

export const GET_AVAILABLE_DATASET_SUMMARY_REQUEST = 'GET_AVAILABLE_DATASET_SUMMARY_REQUEST';
export const GET_AVAILABLE_DATASET_SUMMARY_SUCCESS = 'GET_AVAILABLE_DATASET_SUMMARY_SUCCESS';
export const GET_AVAILABLE_DATASET_SUMMARY_FAILURE = 'GET_AVAILABLE_DATASET_SUMMARY_FAILURE';

//Public Nexsets

export const GET_PUBLIC_DATASETS_REQUEST = 'GET_PUBLIC_DATASETS_REQUEST';
export const GET_PUBLIC_DATASETS_SUCCESS = 'GET_PUBLIC_DATASETS_SUCCESS';
export const GET_PUBLIC_DATASETS_FAILURE = 'GET_PUBLIC_DATASETS_FAILURE';

export const GET_PUBLIC_DATASETS_SUMMARY_REQUEST = 'GET_PUBLIC_DATASETS_SUMMARY_REQUEST';
export const GET_PUBLIC_DATASETS_SUMMARY_SUCCESS = 'GET_PUBLIC_DATASETS_SUMMARY_SUCCESS';
export const GET_PUBLIC_DATASETS_SUMMARY_FAILURE = 'GET_PUBLIC_DATASETS_SUMMARY_FAILURE';

export const GET_PUBLIC_DATASET_REQUEST = 'GET_PUBLIC_DATASET_REQUEST';
export const GET_PUBLIC_DATASET_SUCCESS = 'GET_PUBLIC_DATASET_SUCCESS';
export const GET_PUBLIC_DATASET_FAILURE = 'GET_PUBLIC_DATASET_FAILURE';

export const GET_PUBLIC_DATASET_SUMMARY_REQUEST = 'GET_PUBLIC_DATASET_SUMMARY_REQUEST';
export const GET_PUBLIC_DATASET_SUMMARY_SUCCESS = 'GET_PUBLIC_DATASET_SUMMARY_SUCCESS';
export const GET_PUBLIC_DATASET_SUMMARY_FAILURE = 'GET_PUBLIC_DATASET_SUMMARY_FAILURE';

//My data sinks

export const GET_SINKS_REQUEST = 'GET_SINKS_REQUEST';
export const GET_SINKS_SUCCESS = 'GET_SINKS_SUCCESS';
export const GET_SINKS_FAILURE = 'GET_SINKS_FAILURE';

export const GET_SINK_REQUEST = 'GET_SINK_REQUEST';
export const GET_SINK_SUCCESS = 'GET_SINK_SUCCESS';
export const GET_SINK_FAILURE = 'GET_SINK_FAILURE';

export const SEARCH_SINK_REQUEST = 'SEARCH_SINK_REQUEST';
export const SEARCH_SINK_SUCCESS = 'SEARCH_SINK_SUCCESS';
export const SEARCH_SINK_FAILURE = 'SEARCH_SINK_FAILURE';

export const ADD_SINK_REQUEST = 'ADD_SINK_REQUEST';
export const ADD_SINK_SUCCESS = 'ADD_SINK_SUCCESS';
export const ADD_SINK_FAILURE = 'ADD_SINK_FAILURE';

export const COPY_SINK_REQUEST = 'COPY_SINK_REQUEST';
export const COPY_SINK_SUCCESS = 'COPY_SINK_SUCCESS';
export const COPY_SINK_FAILURE = 'COPY_SINK_FAILURE';

export const UPDATE_SINK_INFO_REQUEST = 'UPDATE_SINK_INFO_REQUEST';
export const UPDATE_SINK_INFO_SUCCESS = 'UPDATE_SINK_INFO_SUCCESS';
export const UPDATE_SINK_INFO_FAILURE = 'UPDATE_SINK_INFO_FAILURE';

export const DELETE_SINK_REQUEST = 'DELETE_SINK_REQUEST';
export const DELETE_SINK_SUCCESS = 'DELETE_SINK_SUCCESS';
export const DELETE_SINK_FAILURE = 'DELETE_SINK_FAILURE';

export const ACTIVATE_SINK_REQUEST = 'ACTIVATE_SINK_REQUEST';
export const PAUSE_SINK_REQUEST = 'PAUSE_SINK_REQUEST';

//Data Maps
export const GET_DATA_MAPS_REQUEST = 'GET_DATA_MAPS_REQUEST';
export const GET_DATA_MAPS_SUCCESS = 'GET_DATA_MAPS_SUCCESS';
export const GET_DATA_MAPS_FAILURE = 'GET_DATA_MAPS_FAILURE';

export const SEARCH_DATA_MAPS_REQUEST = 'SEARCH_DATA_MAPS_REQUEST';
export const SEARCH_DATA_MAPS_SUCCESS = 'SEARCH_DATA_MAPS_SUCCESS';
export const SEARCH_DATA_MAPS_FAILURE = 'SEARCH_DATA_MAPS_FAILURE';

export const GET_ALL_DATA_MAPS_REQUEST = 'GET_ALL_DATA_MAPS_REQUEST';
export const GET_ALL_DATA_MAPS_SUCCESS = 'GET_ALL_DATA_MAPS_SUCCESS';
export const GET_ALL_DATA_MAPS_FAILURE = 'GET_ALL_DATA_MAPS_FAILURE';

export const GET_DATA_MAP_REQUEST = 'GET_DATA_MAP_REQUEST';
export const GET_DATA_MAP_SUCCESS = 'GET_DATA_MAP_SUCCESS';
export const GET_DATA_MAP_FAILURE = 'GET_DATA_MAP_FAILURE';

export const DELETE_DATA_MAP_REQUEST = 'DELETE_DATA_MAP_REQUEST';
export const DELETE_DATA_MAP_SUCCESS = 'DELETE_DATA_MAP_SUCCESS';
export const DELETE_DATA_MAP_FAILURE = 'DELETE_DATA_MAP_FAILURE';

export const CREATE_DATA_MAP_REQUEST = 'CREATE_DATA_MAP_REQUEST';
export const CREATE_DATA_MAP_SUCCESS = 'CREATE_DATA_MAP_SUCCESS';
export const CREATE_DATA_MAP_FAILURE = 'CREATE_DATA_MAP_FAILURE';

export const UPDATE_DATA_MAP_REQUEST = 'UPDATE_DATA_MAP_REQUEST';
export const UPDATE_DATA_MAP_SUCCESS = 'UPDATE_DATA_MAP_SUCCESS';
export const UPDATE_DATA_MAP_FAILURE = 'UPDATE_DATA_MAP_FAILURE';

export const GET_DATA_MAP_SAMPLES_REQUEST = 'GET_DATA_MAP_SAMPLES_REQUEST';
export const GET_DATA_MAP_SAMPLES_SUCCESS = 'GET_DATA_MAP_SAMPLES_SUCCESS';
export const GET_DATA_MAP_SAMPLES_FAILURE = 'GET_DATA_MAP_SAMPLES_FAILURE';

export const GET_DATA_MAP_ENTRY_REQUEST = 'GET_DATA_MAP_ENTRY_REQUEST';
export const GET_DATA_MAP_ENTRY_SUCCESS = 'GET_DATA_MAP_ENTRY_SUCCESS';
export const GET_DATA_MAP_ENTRY_FAILURE = 'GET_DATA_MAP_ENTRY_FAILURE';

export const SAVE_DATA_MAP_ENTRIES_REQUEST = 'SAVE_DATA_MAP_ENTRIES_REQUEST';
export const SAVE_DATA_MAP_ENTRIES_SUCCESS = 'SAVE_DATA_MAP_ENTRIES_SUCCESS';
export const SAVE_DATA_MAP_ENTRIES_FAILURE = 'SAVE_DATA_MAP_ENTRIES_FAILURE';

export const DELETE_DATA_MAP_ENTRIES_REQUEST = 'DELETE_DATA_MAP_ENTRIES_REQUEST';
export const DELETE_DATA_MAP_ENTRIES_SUCCESS = 'DELETE_DATA_MAP_ENTRIES_SUCCESS';
export const DELETE_DATA_MAP_ENTRIES_FAILURE = 'DELETE_DATA_MAP_ENTRIES_FAILURE';

export const GET_DATA_MAP_DOC_REQUEST = 'GET_DATA_MAP_DOC_REQUEST';
export const GET_DATA_MAP_DOC_SUCCESS = 'GET_DATA_MAP_DOC_SUCCESS';
export const GET_DATA_MAP_DOC_FAILURE = 'GET_DATA_MAP_DOC_FAILURE';

export const UPDATE_DATA_MAP_DOC_REQUEST = 'UPDATE_DATA_MAP_DOC_REQUEST';
export const UPDATE_DATA_MAP_DOC_SUCCESS = 'UPDATE_DATA_MAP_DOC_SUCCESS';
export const UPDATE_DATA_MAP_DOC_FAILURE = 'UPDATE_DATA_MAP_DOC_FAILURE';

export const DATA_MAP_CLEAR_SEARCH_RESULTS = 'DATA_MAP_CLEAR_SEARCH_RESULTS';

export const CLEAR_DATA_MAP_STATE_TO_INITIAL = 'CLEAR_DATA_MAP_STATE_TO_INITIAL';
export const ADD_DATA_MAP = 'CREATE_DATA_MAP';
export const BEGIN_DATA_MAP_SAVE = 'BEGIN_DATA_MAP_SAVE';
export const END_DATA_MAP_SAVE = 'END_DATA_MAP_SAVE';
export const SET_PROPERTY_KEY_DATA_MAPS = 'SET_PROPERTY_KEY_DATA_MAPS';
export const REMOVE_PRIMARY_KEY_PROPERTY_KEY_DATA_MAPS =
  'REMOVE_PRIMARY_KEY_PROPERTY_KEY_DATA_MAPS';
export const DATA_MAP_SET_INITIAL_STATE = 'DATA_MAP_SET_INITIAL_STATE';
export const RESET_DELETED_DATA_MAP_ROWS = 'RESET_DELETED_DATA_MAP_ROWS';
export const RESET_NEW_DATA_MAP_ROWS = 'RESET_NEW_DATA_MAP_ROWS';
export const RESET_EDITED_DATA_MAP_ROWS = 'RESET_EDITED_DATA_MAP_ROWS';
export const UPDATE_DATA_MAP_META = 'UPDATE_DATA_MAP_META';
export const SET_DATA_MAP_INSERT_TYPE = 'SET_DATA_MAP_INSERT_TYPE';
export const SET_DATA_MAP_WRITE_MODE = 'SET_DATA_MAP_WRITE_MODE';
export const EDIT_DATA_MAP_BULK_INSERT_TEXT = 'EDIT_DATA_MAP_BULK_INSERT_TEXT';
export const EDIT_DATA_MAP_SELECTED_FILE = 'EDIT_DATA_MAP_SELECTED_FILE';
export const CLOSE_DATA_MAP_KEY_FORM = 'CLOSE_DATA_MAP_KEY_FORM';
export const TOGGLE_DATA_MAP_KEY_FORM = 'TOGGLE_DATA_MAP_KEY_FORM';
export const SET_DYNAMIC_DATA_MAP_ROWS = 'SET_DYNAMIC_DATA_MAP_ROWS';
export const UPDATE_DATA_MAP_ROW_CELL = 'UPDATE_DATA_MAP_ROW_CELL';
export const UPDATE_DATA_MAP_ROW_BEING_ADDED = 'UPDATE_DATA_MAP_ROW_BEING_ADDED';
export const DELETE_DATA_MAP_ROW = 'DELETE_DATA_MAP_ROW';
export const UNDO_DELETE_DATA_MAP_ROW = 'UNDO_DELETE_DATA_MAP_ROW';
export const DELETE_DATA_MAP_PROP_KEY = 'DELETE_DATA_MAP_PROP_KEY';
export const SET_DATA_MAP_PROPERTY_KEY = 'SET_DATA_MAP_PROPERTY_KEY';
export const SET_DATA_MAP_DEFAULT = 'SET_DATA_MAP_DEFAULT';
export const SET_DATA_MAP_PRIMARY_KEY = 'SET_DATA_MAP_PRIMARY_KEY';
export const UPDATE_DATA_MAP_FIELD = 'UPDATE_DATA_MAP_FIELD';
export const SET_DATA_MAP_SEARCH_TERM = 'SET_DATA_MAP_SEARCH_TERM';
export const ADD_A_NEW_DATA_MAP_ROW = 'ADD_A_NEW_DATA_MAP_ROW';
export const DELETE_DATA_MAP_ROW_BEING_ADDED = 'DELETE_DATA_MAP_ROW_BEING_ADDED';

export const SET_DATA_MAP_KEY_PAGE_FIRST = 'SET_DATA_MAP_KEY_PAGE_FIRST';
export const SET_DATA_MAP_KEY_PAGE_PREV = 'SET_DATA_MAP_KEY_PAGE_PREV';
export const SET_DATA_MAP_KEY_PAGE = 'SET_DATA_MAP_KEY_PAGE';
export const SET_DATA_MAP_KEY_PAGE_NEXT = 'SET_DATA_MAP_KEY_PAGE_NEXT';
export const SET_DATA_MAP_KEY_PAGE_LAST = 'SET_DATA_MAP_KEY_PAGE_LAST';

//Credentials
export const GET_ALL_CREDENTIALS_REQUEST = 'GET_ALL_CREDENTIALS_REQUEST';
export const GET_ALL_CREDENTIALS_SUCCESS = 'GET_ALL_CREDENTIALS_SUCCESS';
export const GET_ALL_CREDENTIALS_FAILURE = 'GET_ALL_CREDENTIALS_FAILURE';

export const GET_CREDENTIALS_REQUEST = 'GET_CREDENTIALS_REQUEST';
export const GET_CREDENTIALS_SUCCESS = 'GET_CREDENTIALS_SUCCESS';
export const GET_CREDENTIALS_FAILURE = 'GET_CREDENTIALS_FAILURE';

export const SEARCH_CREDENTIALS_REQUEST = 'SEARCH_CREDENTIALS_REQUEST';
export const SEARCH_CREDENTIALS_SUCCESS = 'SEARCH_CREDENTIALS_SUCCESS';
export const SEARCH_CREDENTIALS_FAILURE = 'SEARCH_CREDENTIALS_FAILURE';

export const GET_CREDENTIAL_REQUEST = 'GET_CREDENTIAL_REQUEST';
export const GET_CREDENTIAL_SUCCESS = 'GET_CREDENTIAL_SUCCESS';
export const GET_CREDENTIAL_FAILURE = 'GET_CREDENTIAL_FAILURE';

export const GET_CREDENTIAL_SILENT_REQUEST = 'GET_CREDENTIAL_SILENT_REQUEST';
export const GET_CREDENTIAL_SILENT_SUCCESS = 'GET_CREDENTIAL_SILENT_SUCCESS';
export const GET_CREDENTIAL_SILENT_FAILURE = 'GET_CREDENTIAL_SILENT_FAILURE';

export const ADD_CREDENTIAL_REQUEST = 'ADD_CREDENTIAL_REQUEST';
export const ADD_CREDENTIAL_SUCCESS = 'ADD_CREDENTIAL_SUCCESS';
export const ADD_CREDENTIAL_FAILURE = 'ADD_CREDENTIAL_FAILURE';

export const PROBE_CREDENTIAL_REQUEST = 'PROBE_CREDENTIAL_REQUEST';
export const PROBE_CREDENTIAL_SUCCESS = 'PROBE_CREDENTIAL_SUCCESS';
export const PROBE_CREDENTIAL_FAILURE = 'PROBE_CREDENTIAL_FAILURE';
export const PROBE_CREDENTIAL_SILENT_REQUEST = 'PROBE_CREDENTIAL_SILENT_REQUEST';
export const PROBE_CREDENTIAL_SILENT_SUCCESS = 'PROBE_CREDENTIAL_SILENT_SUCCESS';
export const PROBE_CREDENTIAL_SILENT_FAILURE = 'PROBE_CREDENTIAL_SILENT_FAILURE';

export const UPDATE_CREDENTIAL_REQUEST = 'UPDATE_CREDENTIAL_REQUEST';
export const UPDATE_CREDENTIAL_SUCCESS = 'UPDATE_CREDENTIAL_SUCCESS';
export const UPDATE_CREDENTIAL_FAILURE = 'UPDATE_CREDENTIAL_FAILURE';

export const DELETE_CREDENTIAL_REQUEST = 'DELETE_CREDENTIAL_REQUEST';
export const DELETE_CREDENTIAL_SUCCESS = 'DELETE_CREDENTIAL_SUCCESS';
export const DELETE_CREDENTIAL_FAILURE = 'DELETE_CREDENTIAL_FAILURE';

export const ADD_NEW_CREDENTIAL = 'ADD_NEW_CREDENTIAL';
export const TOGGLE_EXPAND_CREDENTIAL = 'TOGGLE_EXPAND_CREDENTIAL';
export const EDIT_CREDENTIAL = 'EDIT_CREDENTIAL';
export const CANCEL_EDIT_CREDENTIAL = 'CANCEL_EDIT_CREDENTIAL';
export const MODIFY_CREDENTIAL = 'MODIFY_CREDENTIAL';
export const MODIFY_AUTH_CREDENTIAL = 'MODIFY_AUTH_CREDENTIAL';

export const GET_CREDENTIALS_GROUPS_REQUEST = 'GET_CREDENTIALS_GROUPS_REQUEST';
export const GET_CREDENTIALS_GROUPS_SUCCESS = 'GET_CREDENTIALS_GROUPS_SUCCESS';
export const GET_CREDENTIALS_GROUPS_FAILURE = 'GET_CREDENTIALS_GROUPS_FAILURE';

export const GET_CREDENTIALS_GROUP_REQUEST = 'GET_CREDENTIALS_GROUP_REQUEST';
export const GET_CREDENTIALS_GROUP_SUCCESS = 'GET_CREDENTIALS_GROUP_SUCCESS';
export const GET_CREDENTIALS_GROUP_FAILURE = 'GET_CREDENTIALS_GROUP_FAILURE';

export const GET_CREDENTIAL_USAGE_REQUEST = 'GET_CREDENTIAL_USAGE_REQUEST';
export const GET_CREDENTIAL_USAGE_SUCCESS = 'GET_CREDENTIAL_USAGE_SUCCESS';
export const GET_CREDENTIAL_USAGE_FAILURE = 'GET_CREDENTIAL_USAGE_FAILURE';

export const CREATE_CREDENTIALS_GROUP_REQUEST = 'CREATE_CREDENTIALS_GROUP_REQUEST';
export const CREATE_CREDENTIALS_GROUP_SUCCESS = 'CREATE_CREDENTIALS_GROUP_SUCCESS';
export const CREATE_CREDENTIALS_GROUP_FAILURE = 'CREATE_CREDENTIALS_GROUP_FAILURE';

export const UPDATE_CREDENTIALS_GROUP_REQUEST = 'UPDATE_CREDENTIALS_GROUP_REQUEST';
export const UPDATE_CREDENTIALS_GROUP_SUCCESS = 'UPDATE_CREDENTIALS_GROUP_SUCCESS';
export const UPDATE_CREDENTIALS_GROUP_FAILURE = 'UPDATE_CREDENTIALS_GROUP_FAILURE';

export const DELETE_CREDENTIALS_GROUP_REQUEST = 'DELETE_CREDENTIALS_GROUP_REQUEST';
export const DELETE_CREDENTIALS_GROUP_SUCCESS = 'DELETE_CREDENTIALS_GROUP_SUCCESS';
export const DELETE_CREDENTIALS_GROUP_FAILURE = 'DELETE_CREDENTIALS_GROUP_FAILURE';

export const GET_CREDENTIALS_GROUP_CREDENTIALS_REQUEST =
  'GET_CREDENTIALS_GROUP_CREDENTIALS_REQUEST';
export const GET_CREDENTIALS_GROUP_CREDENTIALS_SUCCESS =
  'GET_CREDENTIALS_GROUP_CREDENTIALS_SUCCESS';
export const GET_CREDENTIALS_GROUP_CREDENTIALS_FAILURE =
  'GET_CREDENTIALS_GROUP_CREDENTIALS_FAILURE';

export const GET_ALL_CREDENTIALS_GROUP_CREDENTIALS_REQUEST =
  'GET_ALL_CREDENTIALS_GROUP_CREDENTIALS_REQUEST';
export const GET_ALL_CREDENTIALS_GROUP_CREDENTIALS_SUCCESS =
  'GET_ALL_CREDENTIALS_GROUP_CREDENTIALS_SUCCESS';
export const GET_ALL_CREDENTIALS_GROUP_CREDENTIALS_FAILURE =
  'GET_ALL_CREDENTIALS_GROUP_CREDENTIALS_FAILURE';

//notifications
export const GET_RESOURCE_NOTIFICATIONS_REQUEST = 'GET_RESOURCE_NOTIFICATIONS_REQUEST';
export const GET_RESOURCE_NOTIFICATIONS_SUCCESS = 'GET_RESOURCE_NOTIFICATIONS_SUCCESS';
export const GET_RESOURCE_NOTIFICATIONS_FAILURE = 'GET_RESOURCE_NOTIFICATIONS_FAILURE';

export const GET_ALL_NOTIFICATIONS_REQUEST = 'GET_ALL_NOTIFICATIONS_REQUEST';
export const GET_ALL_NOTIFICATIONS_SUCCESS = 'GET_ALL_NOTIFICATIONS_SUCCESS';
export const GET_ALL_NOTIFICATIONS_FAILURE = 'GET_ALL_NOTIFICATIONS_FAILURE';

export const GET_ALL_NOTIFICATIONS_SOURCE_REQUEST = 'GET_ALL_NOTIFICATIONS_SOURCE_REQUEST';
export const GET_ALL_NOTIFICATIONS_SOURCE_SUCCESS = 'GET_ALL_NOTIFICATIONS_SOURCE_SUCCESS';
export const GET_ALL_NOTIFICATIONS_SOURCE_FAILURE = 'GET_ALL_NOTIFICATIONS_SOURCE_FAILURE';

export const GET_ALL_NOTIFICATIONS_SET_REQUEST = 'GET_ALL_NOTIFICATIONS_SET_REQUEST';
export const GET_ALL_NOTIFICATIONS_SET_SUCCESS = 'GET_ALL_NOTIFICATIONS_SET_SUCCESS';
export const GET_ALL_NOTIFICATIONS_SET_FAILURE = 'GET_ALL_NOTIFICATIONS_SET_FAILURE';

export const GET_ALL_NOTIFICATIONS_ALERT_REQUEST = 'GET_ALL_NOTIFICATIONS_ALERT_REQUEST';
export const GET_ALL_NOTIFICATIONS_ALERT_SUCCESS = 'GET_ALL_NOTIFICATIONS_ALERT_SUCCESS';
export const GET_ALL_NOTIFICATIONS_ALERT_FAILURE = 'GET_ALL_NOTIFICATIONS_ALERT_FAILURE';

export const GET_UNREAD_NOTIFICATIONS_REQUEST = 'GET_UNREAD_NOTIFICATIONS_REQUEST';
export const GET_UNREAD_NOTIFICATIONS_SUCCESS = 'GET_UNREAD_NOTIFICATIONS_SUCCESS';
export const GET_UNREAD_NOTIFICATIONS_FAILURE = 'GET_UNREAD_NOTIFICATIONS_FAILURE';

export const GET_UNREAD_COUNTER_NOTIFICATIONS_REQUEST = 'GET_UNREAD_COUNTER_NOTIFICATIONS_REQUEST';
export const GET_UNREAD_COUNTER_NOTIFICATIONS_SUCCESS = 'GET_UNREAD_COUNTER_NOTIFICATIONS_SUCCESS';
export const GET_UNREAD_COUNTER_NOTIFICATIONS_FAILURE = 'GET_UNREAD_COUNTER_NOTIFICATIONS_FAILURE';

export const NEXT_NOTIFICATION_PAGE = 'NEXT_NOTIFICATION_PAGE';
export const PREV_NOTIFICATION_PAGE = 'PREV_NOTIFICATION_PAGE';

export const UPDATE_NOTIFICATION_AS_READ = 'UPDATE_NOTIFICATION_AS_READ';
export const UPDATE_NOTIFICATION_AS_READ_SUCCESS = 'UPDATE_NOTIFICATION_AS_READ_SUCCESS';
export const UPDATE_NOTIFICATION_AS_READ_FAILURE = 'UPDATE_NOTIFICATION_AS_READ_FAILURE';

export const UPDATE_RESOURCE_NOTIFICATION_AS_READ = 'UPDATE_RESOURCE_NOTIFICATION_AS_READ';
export const UPDATE_RESOURCE_NOTIFICATION_AS_READ_SUCCESS =
  'UPDATE_RESOURCE_NOTIFICATION_AS_READ_SUCCESS';
export const UPDATE_RESOURCE_NOTIFICATION_AS_READ_FAILURE =
  'UPDATE_RESOURCE_NOTIFICATION_AS_READ_FAILURE';

export const DELETE_RESOURCE_NOTIFICATION_REQUEST = 'DELETE_RESOURCE_NOTIFICATION_REQUEST';
export const DELETE_RESOURCE_NOTIFICATION_SUCCESS = 'DELETE_RESOURCE_NOTIFICATION_SUCCESS';
export const DELETE_RESOURCE_NOTIFICATION_FAILURE = 'DELETE_RESOURCE_NOTIFICATION_FAILURE';

export const UPDATE_ALL_NOTIFICATIONS_AS_READ = 'UPDATE_ALL_NOTIFICATIONS_AS_READ';
export const UPDATE_ALL_NOTIFICATIONS_AS_READ_SUCCESS = 'UPDATE_ALL_NOTIFICATIONS_AS_READ_SUCCESS';
export const UPDATE_ALL_NOTIFICATIONS_AS_READ_FAILURE = 'UPDATE_ALL_NOTIFICATIONS_AS_READ_FAILURE';

export const UPDATE_NOTIFICATIONS_MANAGER = 'UPDATE_NOTIFICATIONS_MANAGER';

export const GET_NOTIFICATIONS_TYPES_REQUEST = 'GET_NOTIFICATIONS_TYPES_REQUEST';
export const GET_NOTIFICATIONS_TYPES_SUCCESS = 'GET_NOTIFICATIONS_TYPES_SUCCESS';
export const GET_NOTIFICATIONS_TYPES_FAILURE = 'GET_NOTIFICATIONS_TYPES_FAILURE';

export const GET_NOTIFICATIONS_SETTINGS_REQUEST = 'GET_NOTIFICATIONS_SETTINGS_REQUEST';
export const GET_NOTIFICATIONS_SETTINGS_SUCCESS = 'GET_NOTIFICATIONS_SETTINGS_SUCCESS';
export const GET_NOTIFICATIONS_SETTINGS_FAILURE = 'GET_NOTIFICATIONS_SETTINGS_FAILURE';

export const GET_NOTIFICATIONS_CHANNEL_REQUEST = 'GET_NOTIFICATIONS_CHANNEL_REQUEST';
export const GET_NOTIFICATIONS_CHANNEL_SUCCESS = 'GET_NOTIFICATIONS_CHANNEL_SUCCESS';
export const GET_NOTIFICATIONS_CHANNEL_FAILURE = 'GET_NOTIFICATIONS_CHANNEL_FAILURE';

export const CREATE_NOTIFICATIONS_CHANNEL_REQUEST = 'CREATE_NOTIFICATIONS_CHANNEL_REQUEST';
export const CREATE_NOTIFICATIONS_CHANNEL_SUCCESS = 'CREATE_NOTIFICATIONS_CHANNEL_SUCCESS';
export const CREATE_NOTIFICATIONS_CHANNEL_FAILURE = 'CREATE_NOTIFICATIONS_CHANNEL_FAILURE';

export const UPDATE_NOTIFICATIONS_CHANNEL_REQUEST = 'UPDATE_NOTIFICATIONS_CHANNEL_REQUEST';
export const UPDATE_NOTIFICATIONS_CHANNEL_SUCCESS = 'UPDATE_NOTIFICATIONS_CHANNEL_SUCCESS';
export const UPDATE_NOTIFICATIONS_CHANNEL_FAILURE = 'UPDATE_NOTIFICATIONS_CHANNEL_FAILURE';

export const CREATE_NOTIFICATIONS_SETTINGS_REQUEST = 'CREATE_NOTIFICATIONS_SETTINGS_REQUEST';
export const CREATE_NOTIFICATIONS_SETTINGS_SUCCESS = 'CREATE_NOTIFICATIONS_SETTINGS_SUCCESS';
export const CREATE_NOTIFICATIONS_SETTINGS_FAILURE = 'CREATE_NOTIFICATIONS_SETTINGS_FAILURE';

export const UPDATE_NOTIFICATIONS_SETTINGS_REQUEST = 'UPDATE_NOTIFICATIONS_SETTINGS_REQUEST';
export const UPDATE_NOTIFICATIONS_SETTINGS_SUCCESS = 'UPDATE_NOTIFICATIONS_SETTINGS_SUCCESS';
export const UPDATE_NOTIFICATIONS_SETTINGS_FAILURE = 'UPDATE_NOTIFICATIONS_SETTINGS_FAILURE';

export const DELETE_NOTIFICATIONS_SETTINGS_REQUEST = 'DELETE_NOTIFICATIONS_SETTINGS_REQUEST';
export const DELETE_NOTIFICATIONS_SETTINGS_SUCCESS = 'DELETE_NOTIFICATIONS_SETTINGS_SUCCESS';
export const DELETE_NOTIFICATIONS_SETTINGS_FAILURE = 'DELETE_NOTIFICATIONS_SETTINGS_FAILURE';

//resource metrics
export const GET_RESOURCE_METRICS_AGGREGATE_REQUEST = 'GET_RESOURCE_METRICS_AGGREGATE_REQUEST';
export const GET_RESOURCE_METRICS_AGGREGATE_SUCCESS = 'GET_RESOURCE_METRICS_AGGREGATE_SUCCESS';
export const GET_RESOURCE_METRICS_AGGREGATE_FAILURE = 'GET_RESOURCE_METRICS_AGGREGATE_FAILURE';

export const GET_RESOURCE_METRICS_BY_DAYS_REQUEST = 'GET_RESOURCE_METRICS_BY_DAYS_REQUEST';
export const GET_RESOURCE_METRICS_BY_DAYS_SUCCESS = 'GET_RESOURCE_METRICS_BY_DAYS_SUCCESS';
export const GET_RESOURCE_METRICS_BY_DAYS_FAILURE = 'GET_RESOURCE_METRICS_BY_DAYS_FAILURE';

export const GET_RESOURCE_FILES_REQUEST = 'GET_RESOURCE_FILES_REQUEST';
export const GET_RESOURCE_FILES_SUCCESS = 'GET_RESOURCE_FILES_SUCCESS';
export const GET_RESOURCE_FILES_FAILURE = 'GET_RESOURCE_FILES_FAILURE';
export const GET_RESOURCE_FILES_DETAILS_FAILURE = 'GET_RESOURCE_FILES_DETAILS_FAILURE';
export const GET_RESOURCE_FILES_DETAILS_REQUEST = 'GET_RESOURCE_FILES_DETAILS_REQUEST';
export const GET_RESOURCE_FILES_DETAILS_SUCCESS = 'GET_RESOURCE_FILES_DETAILS_SUCCESS';
export const CLEAN_RESOURCE_FILES_DETAILS = 'CLEAN_RESOURCE_FILES_DETAILS';

export const GET_RESOURCE_CRON_HISTORY_REQUEST = 'GET_RESOURCE_CRON_HISTORY_REQUEST';
export const GET_RESOURCE_CRON_HISTORY_SUCCESS = 'GET_RESOURCE_CRON_HISTORY_SUCCESS';
export const GET_RESOURCE_CRON_HISTORY_FAILURE = 'GET_RESOURCE_CRON_HISTORY_FAILURE';

export const GET_AUDIT_LOG_REQUEST = 'GET_AUDIT_LOG_REQUEST';
export const GET_AUDIT_LOG_SUCCESS = 'GET_AUDIT_LOG_SUCCESS';
export const GET_AUDIT_LOG_FAILURE = 'GET_AUDIT_LOG_FAILURE';

export const GET_RESOURCE_COUNT_REQUEST = 'GET_RESOURCE_COUNT_REQUEST';
export const GET_RESOURCE_COUNT_SUCCESS = 'GET_RESOURCE_COUNT_SUCCESS';
export const GET_RESOURCE_COUNT_FAILURE = 'GET_RESOURCE_COUNT_FAILURE';

export const CLEAR_AUDIT_LOG = 'CLEAR_AUDIT_LOG';

export const GET_ACL_REQUEST = 'GET_ACL_REQUEST';
export const GET_ACL_SUCCESS = 'GET_ACL_SUCCESS';
export const GET_ACL_FAILURE = 'GET_ACL_FAILURE';

export const GET_ACCESS_INSIGHTS_REQUEST = 'GET_ACCESS_INSIGHTS_REQUEST';
export const GET_ACCESS_INSIGHTS_SUCCESS = 'GET_ACCESS_INSIGHTS_SUCCESS';
export const GET_ACCESS_INSIGHTS_FAILURE = 'GET_ACCESS_INSIGHTS_FAILURE';

export const UPDATE_ACL_REQUEST = 'UPDATE_ACL_REQUEST';
export const UPDATE_ACL_SUCCESS = 'UPDATE_ACL_SUCCESS';
export const UPDATE_ACL_FAILURE = 'UPDATE_ACL_FAILURE';

export const SHARED_RESOURCES_ACL_REQUEST = 'SHARED_RESOURCES_ACL_REQUEST';
export const SHARED_RESOURCES_ACL_SUCCESS = 'SHARED_RESOURCES_ACL_SUCCESS';
export const SHARED_RESOURCES_ACL_FAILURE = 'SHARED_RESOURCES_ACL_FAILURE';

export const CLEAR_ACL = 'CLEAR_ACL';

export const GET_RESOURCE_FILE_STATS_REQUEST = 'GET_RESOURCE_FILE_STATS_REQUEST';
export const GET_RESOURCE_FILE_STATS_SUCCESS = 'GET_RESOURCE_FILE_STATS_SUCCESS';
export const GET_RESOURCE_FILE_STATS_FAILURE = 'GET_RESOURCE_FILE_STATS_FAILURE';

//user metrics
export const GET_USER_ACCOUNT_SUMMARY_REQUEST = 'GET_USER_ACCOUNT_SUMMARY_REQUEST';
export const GET_USER_ACCOUNT_SUMMARY_SUCCESS = 'GET_USER_ACCOUNT_SUMMARY_SUCCESS';
export const GET_USER_ACCOUNT_SUMMARY_FAILURE = 'GET_USER_ACCOUNT_SUMMARY_FAILURE';

export const GET_USER_RESOURCE_METRICS_AGGREGATE_REQUEST =
  'GET_USER_RESOURCE_METRICS_AGGREGATE_REQUEST';
export const GET_USER_RESOURCE_METRICS_AGGREGATE_SUCCESS =
  'GET_USER_RESOURCE_METRICS_AGGREGATE_SUCCESS';
export const GET_USER_RESOURCE_METRICS_AGGREGATE_FAILURE =
  'GET_USER_RESOURCE_METRICS_AGGREGATE_FAILURE';

export const GET_USER_RESOURCE_METRICS_N_DAYS_REQUEST = 'GET_USER_RESOURCE_METRICS_N_DAYS_REQUEST';
export const GET_USER_RESOURCE_METRICS_N_DAYS_SUCCESS = 'GET_USER_RESOURCE_METRICS_N_DAYS_SUCCESS';
export const GET_USER_RESOURCE_METRICS_N_DAYS_FAILURE = 'GET_USER_RESOURCE_METRICS_N_DAYS_FAILURE';

export const GET_USER_SOURCE_METRICS_N_DAYS_REQUEST = 'GET_USER_SOURCE_METRICS_N_DAYS_REQUEST';
export const GET_USER_SOURCE_METRICS_N_DAYS_SUCCESS = 'GET_USER_SOURCE_METRICS_N_DAYS_SUCCESS';
export const GET_USER_SOURCE_METRICS_N_DAYS_FAILURE = 'GET_USER_SOURCE_METRICS_N_DAYS_FAILURE';

export const GET_USER_SINK_METRICS_N_DAYS_REQUEST = 'GET_USER_SINK_METRICS_N_DAYS_REQUEST';
export const GET_USER_SINK_METRICS_N_DAYS_SUCCESS = 'GET_USER_SINK_METRICS_N_DAYS_SUCCESS';
export const GET_USER_SINK_METRICS_N_DAYS_FAILURE = 'GET_USER_SINK_METRICS_N_DAYS_FAILURE';

export const GET_ORG_RESOURCE_METRICS_N_DAYS_REQUEST = 'GET_ORG_RESOURCE_METRICS_N_DAYS_REQUEST';
export const GET_ORG_RESOURCE_METRICS_N_DAYS_SUCCESS = 'GET_ORG_RESOURCE_METRICS_N_DAYS_SUCCESS';
export const GET_ORG_RESOURCE_METRICS_N_DAYS_FAILURE = 'GET_ORG_RESOURCE_METRICS_N_DAYS_FAILURE';

export const GET_ORG_SOURCE_METRICS_N_DAYS_REQUEST = 'GET_ORG_SOURCE_METRICS_N_DAYS_REQUEST';
export const GET_ORG_SOURCE_METRICS_N_DAYS_SUCCESS = 'GET_ORG_SOURCE_METRICS_N_DAYS_SUCCESS';
export const GET_ORG_SOURCE_METRICS_N_DAYS_FAILURE = 'GET_ORG_SOURCE_METRICS_N_DAYS_FAILURE';

export const GET_ORG_SINK_METRICS_N_DAYS_REQUEST = 'GET_ORG_SINK_METRICS_N_DAYS_REQUEST';
export const GET_ORG_SINK_METRICS_N_DAYS_SUCCESS = 'GET_ORG_SINK_METRICS_N_DAYS_SUCCESS';
export const GET_ORG_SINK_METRICS_N_DAYS_FAILURE = 'GET_ORG_SINK_METRICS_N_DAYS_FAILURE';

export const GET_USER_ACCOUNT_RESOURCE_METRICS_AGG_REQUEST =
  'GET_USER_ACCOUNT_RESOURCE_METRICS_AGG_REQUEST';
export const GET_USER_ACCOUNT_RESOURCE_METRICS_AGG_SUCCESS =
  'GET_USER_ACCOUNT_RESOURCE_METRICS_AGG_SUCCESS';

export const GET_USER_ACCOUNT_RESOURCE_METRICS_AGG_FAILURE =
  'GET_USER_ACCOUNT_RESOURCE_METRICS_AGG_FAILURE';

//account metrics
export const GET_USER_BILLABLE_EVENTS_TOTAL_REQUEST = 'GET_USER_BILLABLE_EVENTS_TOTAL_REQUEST';
export const GET_USER_BILLABLE_EVENTS_TOTAL_SUCCESS = 'GET_USER_BILLABLE_EVENTS_TOTAL_SUCCESS';
export const GET_USER_BILLABLE_EVENTS_TOTAL_FAILURE = 'GET_USER_BILLABLE_EVENTS_TOTAL_FAILURE';

export const GET_ORG_BILLABLE_EVENTS_TOTAL_REQUEST = 'GET_ORG_BILLABLE_EVENTS_TOTAL_REQUEST';
export const GET_ORG_BILLABLE_EVENTS_TOTAL_SUCCESS = 'GET_ORG_BILLABLE_EVENTS_TOTAL_SUCCESS';
export const GET_ORG_BILLABLE_EVENTS_TOTAL_FAILURE = 'GET_ORG_BILLABLE_EVENTS_TOTAL_FAILURE';

//Probe actions
export const PROBE_GET_TREE_REQUEST = 'PROBE_GET_TREE_REQUEST';
export const PROBE_GET_TREE_SUCCESS = 'PROBE_GET_TREE_SUCCESS';
export const PROBE_GET_TREE_FAILURE = 'PROBE_GET_TREE_FAILURE';

export const PROBE_GET_WSDL_REQUEST = 'PROBE_GET_WSDL_REQUEST';
export const PROBE_GET_WSDL_SUCCESS = 'PROBE_GET_WSDL_SUCCESS';
export const PROBE_GET_WSDL_FAILURE = 'PROBE_GET_WSDL_FAILURE';

export const PROBE_GET_KAFKA_TOPICS_REQUEST = 'PROBE_GET_KAFKA_TOPICS_REQUEST';
export const PROBE_GET_KAFKA_TOPICS_SUCCESS = 'PROBE_GET_KAFKA_TOPICS_SUCCESS';
export const PROBE_GET_KAFKA_TOPICS_FAILURE = 'PROBE_GET_KAFKA_TOPICS_FAILURE';

export const PROBE_CALL_SOAP_REQUEST = 'PROBE_CALL_SOAP_REQUEST';
export const PROBE_CALL_SOAP_SUCCESS = 'PROBE_CALL_SOAP_SUCCESS';
export const PROBE_CALL_SOAP_FAILURE = 'PROBE_CALL_SOAP_FAILURE';

export const PROBE_GET_FILE_REQUEST = 'PROBE_GET_FILE_REQUEST';
export const PROBE_GET_FILE_SUCCESS = 'PROBE_GET_FILE_SUCCESS';
export const PROBE_GET_FILE_FAILURE = 'PROBE_GET_FILE_FAILURE';

export const PROBE_GET_SAMPLE_REQUEST = 'PROBE_GET_SAMPLE_REQUEST';
export const PROBE_GET_SAMPLE_SUCCESS = 'PROBE_GET_SAMPLE_SUCCESS';
export const PROBE_GET_SAMPLE_FAILURE = 'PROBE_GET_SAMPLE_FAILURE';

export const FILE_UPLOAD_PROBE_GET_SAMPLE_REQUEST = 'FILE_UPLOAD_PROBE_GET_SAMPLE_REQUEST';
export const FILE_UPLOAD_PROBE_GET_SAMPLE_SUCCESS = 'FILE_UPLOAD_PROBE_GET_SAMPLE_SUCCESS';
export const FILE_UPLOAD_PROBE_GET_SAMPLE_FAILURE = 'FILE_UPLOAD_PROBE_GET_SAMPLE_FAILURE';
export const FILE_UPLOAD_PROBE_REMOVE_STAGE = 'FILE_UPLOAD_PROBE_REMOVE_STAGE';

export const PROBE_GET_KAFKA_TOPIC_SAMPLE_REQUEST = 'PROBE_GET_KAFKA_TOPIC_SAMPLE_REQUEST';
export const PROBE_GET_KAFKA_TOPIC_SAMPLE_SUCCESS = 'PROBE_GET_KAFKA_TOPIC_SAMPLE_SUCCESS';
export const PROBE_GET_KAFKA_TOPIC_SAMPLE_FAILURE = 'PROBE_GET_KAFKA_TOPIC_SAMPLE_FAILURE';

export const PROBE_CLEAR_ALL = 'PROBE_CLEAR_ALL';
export const PROBE_REMOVE_REST_STAGE = 'PROBE_REMOVE_REST_STAGE';
export const PROBE_CLEAR_FILES = 'PROBE_CLEAR_FILE';

export const PROBE_TOGGLE_NODE = 'PROBE_TOGGLE_NODE';

//Transform actions
export const GET_REUSABLE_RECORD_TRANSFORMS_REQUEST = 'GET_REUSABLE_RECORD_TRANSFORMS_REQUEST';
export const GET_REUSABLE_RECORD_TRANSFORMS_SUCCESS = 'GET_REUSABLE_RECORD_TRANSFORMS_SUCCESS';
export const GET_REUSABLE_RECORD_TRANSFORMS_FAILURE = 'GET_REUSABLE_RECORD_TRANSFORMS_FAILURE';

export const GET_PUBLIC_REUSABLE_RECORD_TRANSFORMS_REQUEST =
  'GET_PUBLIC_REUSABLE_RECORD_TRANSFORMS_REQUEST';
export const GET_PUBLIC_REUSABLE_RECORD_TRANSFORMS_SUCCESS =
  'GET_PUBLIC_REUSABLE_RECORD_TRANSFORMS_SUCCESS';
export const GET_PUBLIC_REUSABLE_RECORD_TRANSFORMS_FAILURE =
  'GET_PUBLIC_REUSABLE_RECORD_TRANSFORMS_FAILURE';

export const GET_CODE_CONTAINER_REQUEST = 'GET_CODE_CONTAINER_REQUEST';
export const GET_CODE_CONTAINER_SUCCESS = 'GET_CODE_CONTAINER_SUCCESS';
export const GET_CODE_CONTAINER_FAILURE = 'GET_CODE_CONTAINER_FAILURE';

export const DELETE_CODE_CONTAINER_REQUEST = 'DELETE_CODE_CONTAINER_REQUEST';
export const DELETE_CODE_CONTAINER_SUCCESS = 'DELETE_CODE_CONTAINER_SUCCESS';
export const DELETE_CODE_CONTAINER_FAILURE = 'DELETE_CODE_CONTAINER_FAILURE';

export const UPDATE_CODE_CONTAINER_REQUEST = 'UPDATE_CODE_CONTAINER_REQUEST';
export const UPDATE_CODE_CONTAINER_SUCCESS = 'UPDATE_CODE_CONTAINER_SUCCESS';
export const UPDATE_CODE_CONTAINER_FAILURE = 'UPDATE_CODE_CONTAINER_FAILURE';

export const UPDATE_RECORD_TX_REUSABILITY_REQUEST = 'UPDATE_RECORD_TX_REUSABILITY_REQUEST';
export const UPDATE_RECORD_TX_REUSABILITY_SUCCESS = 'UPDATE_RECORD_TX_REUSABILITY_SUCCESS';
export const UPDATE_RECORD_TX_REUSABILITY_FAILURE = 'UPDATE_RECORD_TX_REUSABILITY_FAILURE';

export const CREATE_CODE_CONTAINER_REQUEST = 'CREATE_CODE_CONTAINER_REQUEST';
export const CREATE_CODE_CONTAINER_SUCCESS = 'CREATE_CODE_CONTAINER_SUCCESS';
export const CREATE_CODE_CONTAINER_FAILURE = 'CREATE_CODE_CONTAINER_FAILURE';

export const DELETE_RECORD_TRANSFORM_REQUEST = 'DELETE_RECORD_TRANSFORM_REQUEST';
export const DELETE_RECORD_TRANSFORM_SUCCESS = 'DELETE_RECORD_TRANSFORM_SUCCESS';
export const DELETE_RECORD_TRANSFORM_FAILURE = 'DELETE_RECORD_TRANSFORM_FAILURE';

export const GET_TRANSFORM_FEATURES_REQUEST = 'GET_TRANSFORM_FEATURES_REQUEST';
export const GET_TRANSFORM_FEATURES_SUCCESS = 'GET_TRANSFORM_FEATURES_SUCCESS';
export const GET_TRANSFORM_FEATURES_FAILURE = 'GET_TRANSFORM_FEATURES_FAILURE';

export const GET_ATTR_TRANSFORMS_REQUEST = 'GET_ATTR_TRANSFORMS_REQUEST';
export const GET_ATTR_TRANSFORMS_SUCCESS = 'GET_ATTR_TRANSFORMS_SUCCESS';
export const GET_ATTR_TRANSFORMS_FAILURE = 'GET_ATTR_TRANSFORMS_FAILURE';

export const GET_PUBLIC_ATTR_TRANSFORMS_REQUEST = 'GET_PUBLIC_ATTR_TRANSFORMS_REQUEST';
export const GET_PUBLIC_ATTR_TRANSFORMS_SUCCESS = 'GET_PUBLIC_ATTR_TRANSFORMS_SUCCESS';
export const GET_PUBLIC_ATTR_TRANSFORMS_FAILURE = 'GET_PUBLIC_ATTR_TRANSFORMS_FAILURE';

export const GET_CODE_CONTAINERS_REQUEST = 'GET_CODE_CONTAINERS_REQUEST';
export const GET_CODE_CONTAINERS_SUCCESS = 'GET_CODE_CONTAINERS_SUCCESS';
export const GET_CODE_CONTAINERS_FAILURE = 'GET_CODE_CONTAINERS_FAILURE';

export const GET_CODE_CONTAINERS_AI_FUNCTIONS_REQUEST = 'GET_CODE_CONTAINERS_AI_FUNCTIONS_REQUEST';
export const GET_CODE_CONTAINERS_AI_FUNCTIONS_SUCCESS = 'GET_CODE_CONTAINERS_AI_FUNCTIONS_SUCCESS';
export const GET_CODE_CONTAINERS_AI_FUNCTIONS_FAILURE = 'GET_CODE_CONTAINERS_AI_FUNCTIONS_FAILURE';

export const GET_CODE_CONTAINER_LISTING_REQUEST = 'GET_CODE_CONTAINER_LISTING_REQUEST';
export const GET_CODE_CONTAINER_LISTING_SUCCESS = 'GET_CODE_CONTAINER_LISTING_SUCCESS';
export const GET_CODE_CONTAINER_LISTING_FAILURE = 'GET_CODE_CONTAINER_LISTING_FAILURE';

export const SEARCH_CODE_CONTAINERS_REQUEST = 'SEARCH_CODE_CONTAINERS_REQUEST';
export const SEARCH_CODE_CONTAINERS_SUCCESS = 'SEARCH_CODE_CONTAINERS_SUCCESS';
export const SEARCH_CODE_CONTAINERS_FAILURE = 'SEARCH_CODE_CONTAINERS_FAILURE';

export const GET_PUBLIC_CODE_CONTAINERS_REQUEST = 'GET_PUBLIC_CODE_CONTAINERS_REQUEST';
export const GET_PUBLIC_CODE_CONTAINERS_SUCCESS = 'GET_PUBLIC_CODE_CONTAINERS_SUCCESS';
export const GET_PUBLIC_CODE_CONTAINERS_FAILURE = 'GET_PUBLIC_CODE_CONTAINERS_FAILURE';

export const CREATE_ATTR_TRANSFORM_REQUEST = 'CREATE_ATTR_TRANSFORM_REQUEST';
export const CREATE_ATTR_TRANSFORM_SUCCESS = 'CREATE_ATTR_TRANSFORM_SUCCESS';
export const CREATE_ATTR_TRANSFORM_FAILURE = 'CREATE_ATTR_TRANSFORM_FAILURE';

export const UPDATE_ATTR_TRANSFORM_REQUEST = 'UPDATE_ATTR_TRANSFORM_REQUEST';
export const UPDATE_ATTR_TRANSFORM_SUCCESS = 'UPDATE_ATTR_TRANSFORM_SUCCESS';
export const UPDATE_ATTR_TRANSFORM_FAILURE = 'UPDATE_ATTR_TRANSFORM_FAILURE';

export const DELETE_ATTR_TRANSFORM_REQUEST = 'DELETE_ATTR_TRANSFORM_REQUEST';
export const DELETE_ATTR_TRANSFORM_SUCCESS = 'DELETE_ATTR_TRANSFORM_SUCCESS';
export const DELETE_ATTR_TRANSFORM_FAILURE = 'DELETE_ATTR_TRANSFORM_FAILURE';

export const GET_TRANSFORM_DOC_REQUEST = 'GET_TRANSFORM_DOC_REQUEST';
export const GET_TRANSFORM_DOC_SUCCESS = 'GET_TRANSFORM_DOC_SUCCESS';
export const GET_TRANSFORM_DOC_FAILURE = 'GET_TRANSFORM_DOC_FAILURE';

export const UPDATE_TRANSFORM_DOC_REQUEST = 'UPDATE_TRANSFORM_DOC_REQUEST';
export const UPDATE_TRANSFORM_DOC_SUCCESS = 'UPDATE_TRANSFORM_DOC_SUCCESS';
export const UPDATE_TRANSFORM_DOC_FAILURE = 'UPDATE_TRANSFORM_DOC_FAILURE';

export const SET_LISTING_TRANSFORM_TYPE = 'SET_LISTING_TRANSFORM_TYPE';

//Forms actions
export const FORM_START = 'FORM_START';
export const FORM_DID_TRANSITION_TO_NEXT = 'FORM_DID_TRANSITION_TO_NEXT';
export const FORM_DID_TRANSITION_TO_PREV = 'FORM_DID_TRANSITION_TO_PREV';
export const FORM_DID_END = 'FORM_DID_END';
export const FORM_DID_DISMISS = 'FORM_DID_DISMISS';
export const FORM_DID_UPDATE_STAGE_DATA = 'FORM_DID_UPDATE_STAGE_DATA';
export const FORM_DID_RESET_STAGE_DATA = 'FORM_DID_RESET_STAGE_DATA';
export const FORM_DID_SET_ERROR = 'FORM_DID_SET_ERROR';
export const FORM_DID_CLEAR_ERROR = 'FORM_DID_CLEAR_ERROR';

export const FORM_DID_SET_DIALOG = 'FORM_DID_SET_DIALOG';
export const FORM_DID_UPDATE_VALIDATION_STATUS = 'FORM_DID_UPDATE_VALIDATION_STATUS';
export const FORM_DID_SET_STAGE_INDEX = 'FORM_DID_SET_STAGE_INDEX';
export const FORM_DID_COMPLETE = 'FORM_DID_COMPLETE';

//Schema Editor actions
export const SCHEMA_EDITOR_INIT = 'SCHEMA_EDITOR_INIT';
export const SCHEMA_EDITOR_RESET = 'SCHEMA_EDITOR_RESET';
export const SCHEMA_EDITOR_CLEAR_ERROR = 'SCHEMA_EDITOR_CLEAR_ERROR';

export const SCHEMA_EDITOR_INIT_OPTIONS = 'SCHEMA_EDITOR_INIT_OPTIONS';

export const SCHEMA_EDITOR_UPDATE_INPUT_SCHEMA = 'SCHEMA_EDITOR_UPDATE_INPUT_SCHEMA';

export const SCHEMA_EDITOR_UPDATE_SAMPLES = 'SCHEMA_EDITOR_UPDATE_SAMPLES';
export const SCHEMA_EDITOR_UPDATE_OUTPUT_SAMPLES = 'SCHEMA_EDITOR_UPDATE_OUTPUT_SAMPLES';

//Recipe Builder

export const RECIPE_BUILDER_SET_RECIPE_GROUPS = 'RECIPE_BUILDER_SET_RECIPE_GROUPS';
export const RECIPE_BUILDER_RESET_RECIPE_GROUPS = 'RECIPE_BUILDER_RESET_RECIPE_GROUPS';
export const RECIPE_BUILDER_SET_EXPANDED_RECIPE_GROUP = 'RECIPE_BUILDER_SET_EXPANDED_RECIPE_GROUP';
export const RECIPE_BUILDER_SET_EXPANDED_RECIPE = 'RECIPE_BUILDER_SET_EXPANDED_RECIPE';
export const RECIPE_BUILDER_RECIPE_APPLIED = 'RECIPE_BUILDER_RECIPE_APPLIED';
export const RECIPE_BUILDER_SELECT_ATTR = 'RECIPE_BUILDER_SELECT_ATTR';
export const RECIPE_BUILDER_SELECT_ALL_ATTRS = 'RECIPE_BUILDER_SELECT_ALL_ATTRS';
export const RECIPE_BUILDER_DESELECT_ATTR = 'RECIPE_BUILDER_DESELECT_ATTR';
export const RECIPE_BUILDER_DESELECT_ALL_ATTRS = 'RECIPE_BUILDER_DESELECT_ALL_ATTRS';
export const RECIPE_BUILDER_APPLY_SCHEMA_SPEC = 'RECIPE_BUILDER_APPLY_SCHEMA_SPEC';
export const RECIPE_BUILDER_SET_IS_ASYNC = 'RECIPE_BUILDER_SET_IS_ASYNC';
export const RECIPE_BUILDER_SET_PARSING_ERRORS = 'RECIPE_BUILDER_SET_PARSING_ERRORS';
export const RECIPE_BUILDER_SET_LEGACY_MODE = 'RECIPE_BUILDER_SET_LEGACY_MODE';

//View constants
export const UPDATE_SEARCH_FILTERS = 'UPDATE_SEARCH_FILTERS';
export const CLEAR_RESOURCE_SUGGESTIONS = 'CLEAR_RESOURCE_SUGGESTIONS';

export const TOGGLE_NOTIFICATIONS_LIST_VIEW = 'TOGGLE_NOTIFICATIONS_LIST_VIEW';

export const LISTING_SELECT_CARD = 'LISTING_SELECT_CARD';
export const LISTING_DESELECT_CARD = 'LISTING_DESELECT_CARD';
export const LISTING_SET_LAYOUT = 'LISTING_SET_LAYOUT';
export const LISTING_SET_CURRENT_PAGE = 'LISTING_SET_CURRENT_PAGE';
export const LISTING_SET_TOTAL_PAGES = 'LISTING_SET_TOTAL_PAGES';
export const LISTING_SET_TOTAL_ITEMS = 'LISTING_SET_TOTAL_ITEMS';
export const LISTING_RESET_PAGE_NUMBERS = 'LISTING_RESET_PAGE_NUMBERS';
export const LISTING_SET_SORT_CRITERIA = 'LISTING_SET_SORT_CRITERIA';
export const LISTING_SET_ACL_QUERY_MODE = 'LISTING_SET_ACL_QUERY_MODE';
export const SET_ACCESS_CONTROL = 'SET_ACCESS_CONTROL';
export const CLEAR_ACCESS_CONTROL = 'CLEAR_ACCESS_CONTROL';

export const SET_CONTEXTUAL_SUPPORT = 'SET_CONTEXTUAL_SUPPORT';
export const SET_CONTEXTUAL_SUPPORT_VISIBILITY = 'SET_CONTEXTUAL_SUPPORT_VISIBILITY';
export const UNSET_CONTEXTUAL_SUPPORT = 'UNSET_CONTEXTUAL_SUPPORT';

//Pipelines
export const GET_PIPELINES_REQUEST = 'GET_PIPELINES_REQUEST';
export const GET_PIPELINES_SUCCESS = 'GET_PIPELINES_SUCCESS';
export const GET_PIPELINES_FAILURE = 'GET_PIPELINES_FAILURE';

export const GET_FLOWS_WITH_PROJECTS_REQUEST = 'GET_FLOWS_WITH_PROJECTS_REQUEST';
export const GET_FLOWS_WITH_PROJECTS_SUCCESS = 'GET_FLOWS_WITH_PROJECTS_SUCCESS';
export const GET_FLOWS_WITH_PROJECTS_FAILURE = 'GET_FLOWS_WITH_PROJECTS_FAILURE';
export const GET_FLOWS_WITH_PROJECTS_COUNT_REQUEST = 'GET_FLOWS_WITH_PROJECTS_COUNT_REQUEST';
export const GET_FLOWS_WITH_PROJECTS_COUNT_SUCCESS = 'GET_FLOWS_WITH_PROJECTS_COUNT_SUCCESS';
export const GET_FLOWS_WITH_PROJECTS_COUNT_FAILURE = 'GET_FLOWS_WITH_PROJECTS_COUNT_FAILURE';

export const GET_FLOWS_WITHOUT_PROJECTS_REQUEST = 'GET_FLOWS_WITHOUT_PROJECTS_REQUEST';
export const GET_FLOWS_WITHOUT_PROJECTS_SUCCESS = 'GET_FLOWS_WITHOUT_PROJECTS_SUCCESS';
export const GET_FLOWS_WITHOUT_PROJECTS_FAILURE = 'GET_FLOWS_WITHOUT_PROJECTS_FAILURE';
export const GET_FLOWS_WITHOUT_PROJECTS_CLEANUP = 'GET_FLOWS_WITHOUT_PROJECTS_CLEANUP';

export const GET_FLOWS_WITHOUT_PROJECTS_COUNT_REQUEST = 'GET_FLOWS_WITHOUT_PROJECTS_COUNT_REQUEST';
export const GET_FLOWS_WITHOUT_PROJECTS_COUNT_SUCCESS = 'GET_FLOWS_WITHOUT_PROJECTS_COUNT_SUCCESS';
export const GET_FLOWS_WITHOUT_PROJECTS_COUNT_FAILURE = 'GET_FLOWS_WITHOUT_PROJECTS_COUNT_FAILURE';

export const GET_FLOWS_SQL_AUTOMATIONS_REQUEST = 'GET_FLOWS_SQL_AUTOMATIONS_REQUEST';
export const GET_FLOWS_SQL_AUTOMATIONS_SUCCESS = 'GET_FLOWS_SQL_AUTOMATIONS_SUCCESS';
export const GET_FLOWS_SQL_AUTOMATIONS_FAILURE = 'GET_FLOWS_SQL_AUTOMATIONS_FAILURE';

export const GET_MCP_FLOWS_REQUEST = 'GET_MCP_FLOWS_REQUEST';
export const GET_MCP_FLOWS_SUCCESS = 'GET_MCP_FLOWS_SUCCESS';
export const GET_MCP_FLOWS_FAILURE = 'GET_MCP_FLOWS_FAILURE';

export const SEARCH_PIPELINES_REQUEST = 'SEARCH_PIPELINES_REQUEST';
export const SEARCH_PIPELINES_SUCCESS = 'SEARCH_PIPELINES_SUCCESS';
export const SEARCH_PIPELINES_FAILURE = 'SEARCH_PIPELINES_FAILURE';

export const REFRESH_PIPELINE_REQUEST = 'REFRESH_PIPELINE_REQUEST';
export const REFRESH_PIPELINE_SUCCESS = 'REFRESH_PIPELINE_SUCCESS';
export const REFRESH_PIPELINE_FAILURE = 'REFRESH_PIPELINE_FAILURE';

export const PAUSE_PIPELINE_REQUEST = 'PAUSE_PIPELINE_REQUEST';
export const PAUSE_PIPELINE_SUCCESS = 'PAUSE_PIPELINE_SUCCESS';
export const PAUSE_PIPELINE_FAILURE = 'PAUSE_PIPELINE_FAILURE';

export const ACTIVATE_PIPELINE_REQUEST = 'ACTIVATE_PIPELINE_REQUEST';
export const ACTIVATE_PIPELINE_SUCCESS = 'ACTIVATE_PIPELINE_SUCCESS';
export const ACTIVATE_PIPELINE_FAILURE = 'ACTIVATE_PIPELINE_FAILURE';

export const DELETE_PIPELINE_REQUEST = 'DELETE_PIPELINE_REQUEST';
export const DELETE_PIPELINE_SUCCESS = 'DELETE_PIPELINE_SUCCESS';
export const DELETE_PIPELINE_FAILURE = 'DELETE_PIPELINE_FAILURE';

export const RESTORE_PIPELINE_REQUEST = 'RESTORE_PIPELINE_REQUEST';
export const RESTORE_PIPELINE_SUCCESS = 'RESTORE_PIPELINE_SUCCESS';
export const RESTORE_PIPELINE_FAILURE = 'RESTORE_PIPELINE_FAILURE';

export const GET_DENORMALIZED_PIPELINE_REQUEST = 'GET_DENORMALIZED_PIPELINE_REQUEST';
export const GET_DENORMALIZED_PIPELINE_SUCCESS = 'GET_DENORMALIZED_PIPELINE_SUCCESS';
export const GET_DENORMALIZED_PIPELINE_FAILURE = 'GET_DENORMALIZED_PIPELINE_FAILURE';

export const SELECT_PIPELINE_ITEM = 'SELECT_PIPELINE_ITEM';
export const DESELECT_ALL_PIPELINE_ITEMS = 'DESELECT_ALL_PIPELINE_ITEMS';

export const SET_PIPELINE_ACTION = 'SET_PIPELINE_ACTION';

export const GET_TAGS_REQUEST = 'GET_TAGS_REQUEST';
export const GET_TAGS_SUCCESS = 'GET_TAGS_SUCCESS';
export const GET_TAGS_FAILURE = 'GET_TAGS_FAILURE';

export const ADD_TAGS_REQUEST = 'ADD_TAGS_REQUEST';
export const ADD_TAGS_SUCCESS = 'ADD_TAGS_SUCCESS';
export const ADD_TAGS_FAILURE = 'ADD_TAGS_FAILURE';

export const DELETE_TAGS_REQUEST = 'DELETE_TAGS_REQUEST';
export const DELETE_TAGS_SUCCESS = 'DELETE_TAGS_SUCCESS';
export const DELETE_TAGS_FAILURE = 'DELETE_TAGS_FAILURE';

export const SELECT_TAGS = 'SELECT_TAGS';

export const GET_VENDORS_REQUEST = 'GET_VENDORS_REQUEST';
export const GET_VENDORS_SUCCESS = 'GET_VENDORS_SUCCESS';
export const GET_VENDORS_FAILURE = 'GET_VENDORS_FAILURE';

export const GET_FULL_VENDOR_REQUEST = 'GET_FULL_VENDOR_REQUEST';
export const GET_FULL_VENDOR_SUCCESS = 'GET_FULL_VENDOR_SUCCESS';
export const GET_FULL_VENDOR_FAILURE = 'GET_FULL_VENDOR_FAILURE';

export const GET_VENDOR_AUTH_PARAMS_REQUEST = 'GET_VENDOR_AUTH_PARAMS_REQUEST';
export const GET_VENDOR_AUTH_PARAMS_SUCCESS = 'GET_VENDOR_AUTH_PARAMS_SUCCESS';
export const GET_VENDOR_AUTH_PARAMS_FAILURE = 'GET_VENDOR_AUTH_PARAMS_FAILURE';

export const GET_VENDOR_ENDPOINTS_REQUEST = 'GET_VENDOR_ENDPOINTS_REQUEST';
export const GET_VENDOR_ENDPOINTS_SUCCESS = 'GET_VENDOR_ENDPOINTS_SUCCESS';
export const GET_VENDOR_ENDPOINTS_FAILURE = 'GET_VENDOR_ENDPOINTS_FAILURE';

export const GET_VENDOR_ENDPOINT_PARAMS_REQUEST = 'GET_VENDOR_ENDPOINT_PARAMS_REQUEST';
export const GET_VENDOR_ENDPOINT_PARAMS_SUCCESS = 'GET_VENDOR_ENDPOINT_PARAMS_SUCCESS';
export const GET_VENDOR_ENDPOINT_PARAMS_FAILURE = 'GET_VENDOR_ENDPOINT_PARAMS_FAILURE';

export const GET_DB_DATA_TYPES_SUCCESS = 'GET_DB_DATA_TYPES_SUCCESS';

export const GET_RECORD_LINEAGE_REQUEST = 'GET_RECORD_LINEAGE_REQUEST';
export const GET_RECORD_LINEAGE_SUCCESS = 'GET_RECORD_LINEAGE_SUCCESS';
export const GET_RECORD_LINEAGE_FAILURE = 'GET_RECORD_LINEAGE_FAILURE';

export const GET_SCHEMA_SPECS_REQUEST = 'GET_SCHEMA_SPECS_REQUEST';
export const GET_SCHEMA_SPECS_SUCCESS = 'GET_SCHEMA_SPECS_SUCCESS';
export const GET_SCHEMA_SPECS_FAILURE = 'GET_SCHEMA_SPECS_FAILURE';

export const GET_SCHEMA_SPEC_REQUEST = 'GET_SCHEMA_SPEC_REQUEST';
export const GET_SCHEMA_SPEC_SUCCESS = 'GET_SCHEMA_SPEC_SUCCESS';
export const GET_SCHEMA_SPEC_FAILURE = 'GET_SCHEMA_SPEC_FAILURE';

export const GET_SCHEMA_SPEC_LISTING_REQUEST = 'GET_SCHEMA_SPEC_LISTING_REQUEST';
export const GET_SCHEMA_SPEC_LISTING_SUCCESS = 'GET_SCHEMA_SPEC_LISTING_SUCCESS';
export const GET_SCHEMA_SPEC_LISTING_FAILURE = 'GET_SCHEMA_SPEC_LISTING_FAILURE';

export const SEARCH_SCHEMA_SPECS_REQUEST = 'SEARCH_SCHEMA_SPECS_REQUEST';
export const SEARCH_SCHEMA_SPECS_SUCCESS = 'SEARCH_SCHEMA_SPECS_SUCCESS';
export const SEARCH_SCHEMA_SPECS_FAILURE = 'SEARCH_SCHEMA_SPECS_FAILURE';

export const GET_PUBLIC_SCHEMA_SPECS_REQUEST = 'GET_PUBLIC_SCHEMA_SPECS_REQUEST';
export const GET_PUBLIC_SCHEMA_SPECS_SUCCESS = 'GET_PUBLIC_SCHEMA_SPECS_SUCCESS';
export const GET_PUBLIC_SCHEMA_SPECS_FAILURE = 'GET_PUBLIC_SCHEMA_SPECS_FAILURE';

export const CREATE_SCHEMA_SPEC_REQUEST = 'CREATE_SCHEMA_SPEC_REQUEST';
export const CREATE_SCHEMA_SPEC_SUCCESS = 'CREATE_SCHEMA_SPEC_SUCCESS';
export const CREATE_SCHEMA_SPEC_FAILURE = 'CREATE_SCHEMA_SPEC_FAILURE';

export const UPDATE_SCHEMA_SPEC_REQUEST = 'UPDATE_SCHEMA_SPEC_REQUEST';
export const UPDATE_SCHEMA_SPEC_SUCCESS = 'UPDATE_SCHEMA_SPEC_SUCCESS';
export const UPDATE_SCHEMA_SPEC_FAILURE = 'UPDATE_SCHEMA_SPEC_FAILURE';

export const TEST_SCHEMA_SPEC_REQUEST = 'TEST_SCHEMA_SPEC_REQUEST';
export const TEST_SCHEMA_SPEC_SUCCESS = 'TEST_SCHEMA_SPEC_SUCCESS';
export const TEST_SCHEMA_SPEC_FAILURE = 'TEST_SCHEMA_SPEC_FAILURE';

export const DELETE_SCHEMA_SPEC_REQUEST = 'DELETE_SCHEMA_SPEC_REQUEST';
export const DELETE_SCHEMA_SPEC_SUCCESS = 'DELETE_SCHEMA_SPEC_SUCCESS';
export const DELETE_SCHEMA_SPEC_FAILURE = 'DELETE_SCHEMA_SPEC_FAILURE';

export const GET_SCHEMA_SPEC_DOC_REQUEST = 'GET_SCHEMA_SPEC_DOC_REQUEST';
export const GET_SCHEMA_SPEC_DOC_SUCCESS = 'GET_SCHEMA_SPEC_DOC_SUCCESS';
export const GET_SCHEMA_SPEC_DOC_FAILURE = 'GET_SCHEMA_SPEC_DOC_FAILURE';

export const UPDATE_SCHEMA_SPEC_DOC_REQUEST = 'UPDATE_SCHEMA_SPEC_DOC_REQUEST';
export const UPDATE_SCHEMA_SPEC_DOC_SUCCESS = 'UPDATE_SCHEMA_SPEC_DOC_SUCCESS';
export const UPDATE_SCHEMA_SPEC_DOC_FAILURE = 'UPDATE_SCHEMA_SPEC_DOC_FAILURE';

export const CREATE_RESOURCE_API_KEY_REQUEST = 'CREATE_RESOURCE_API_KEY_REQUEST';
export const CREATE_RESOURCE_API_KEY_SUCCESS = 'CREATE_RESOURCE_API_KEY_SUCCESS';
export const CREATE_RESOURCE_API_KEY_FAILURE = 'CREATE_RESOURCE_API_KEY_FAILURE';

export const GET_RESOURCE_API_KEY_REQUEST = 'GET_RESOURCE_API_KEY_REQUEST';
export const GET_RESOURCE_API_KEY_SUCCESS = 'GET_RESOURCE_API_KEY_SUCCESS';
export const GET_RESOURCE_API_KEY_FAILURE = 'GET_RESOURCE_API_KEY_FAILURE';

export const GET_API_KEY_REQUEST = 'GET_API_KEY_REQUEST';
export const GET_API_KEY_SUCCESS = 'GET_API_KEY_SUCCESS';
export const GET_API_KEY_FAILURE = 'GET_API_KEY_FAILURE';

export const GET_ALL_API_KEYS_REQUEST = 'GET_ALL_API_KEYS_REQUEST';
export const GET_ALL_API_KEYS_SUCCESS = 'GET_ALL_API_KEYS_SUCCESS';
export const GET_ALL_API_KEYS_FAILURE = 'GET_ALL_API_KEYS_FAILURE';

export const SEARCH_API_KEYS_REQUEST = 'SEARCH_API_KEYS_REQUEST';
export const SEARCH_API_KEYS_SUCCESS = 'SEARCH_API_KEYS_SUCCESS';
export const SEARCH_API_KEYS_FAILURE = 'SEARCH_API_KEYS_FAILURE';

export const UPDATE_API_KEY_REQUEST = 'UPDATE_API_KEY_REQUEST';
export const UPDATE_API_KEY_SUCCESS = 'UPDATE_API_KEY_SUCCESS';
export const UPDATE_API_KEY_FAILURE = 'UPDATE_API_KEY_FAILURE';

export const PAUSE_API_KEY_REQUEST = 'PAUSE_API_KEY_REQUEST';
export const PAUSE_API_KEY_SUCCESS = 'PAUSE_API_KEY_SUCCESS';
export const PAUSE_API_KEY_FAILURE = 'PAUSE_API_KEY_FAILURE';

export const ACTIVATE_API_KEY_REQUEST = 'ACTIVATE_API_KEY_REQUEST';
export const ACTIVATE_API_KEY_SUCCESS = 'ACTIVATE_API_KEY_SUCCESS';
export const ACTIVATE_API_KEY_FAILURE = 'ACTIVATE_API_KEY_FAILURE';

export const ROTATE_API_KEY_REQUEST = 'ROTATE_API_KEY_REQUEST';
export const ROTATE_API_KEY_SUCCESS = 'ROTATE_API_KEY_SUCCESS';
export const ROTATE_API_KEY_FAILURE = 'ROTATE_API_KEY_FAILURE';

export const DELETE_API_KEY_REQUEST = 'DELETE_API_KEY_REQUEST';
export const DELETE_API_KEY_SUCCESS = 'DELETE_API_KEY_SUCCESS';
export const DELETE_API_KEY_FAILURE = 'DELETE_API_KEY_FAILURE';

export const DATASET_FEED_URL_CREATION_ERROR = 'DATASET_FEED_URL_CREATION_ERROR';

export const SET_DETAIL_VIEW_CARD = 'SET_DETAIL_VIEW_CARD';
export const REMOVE_DETAIL_VIEW_CARD = 'REMOVE_DETAIL_VIEW_CARD';

export const OPEN_RESOURCE_DETAIL_PANEL = 'OPEN_RESOURCE_DETAIL_PANEL';
export const CLOSE_RESOURCE_DETAIL_PANEL = 'CLOSE_RESOURCE_DETAIL_PANEL';

export const OPEN_RESOURCE_EDIT_MODAL = 'OPEN_RESOURCE_EDIT_MODAL';
export const CLOSE_RESOURCE_EDIT_MODAL = 'CLOSE_RESOURCE_EDIT_MODAL';

export const GET_PIPELINE_DOC_REQUEST = 'GET_PIPELINE_DOC_REQUEST';
export const GET_PIPELINE_DOC_SUCCESS = 'GET_PIPELINE_DOC_SUCCESS';
export const GET_PIPELINE_DOC_FAILURE = 'GET_PIPELINE_DOC_FAILURE';

export const GET_PIPELINE_REQUEST = 'GET_PIPELINE_REQUEST';
export const GET_PIPELINE_SUCCESS = 'GET_PIPELINE_SUCCESS';
export const GET_PIPELINE_FAILURE = 'GET_PIPELINE_FAILURE';

export const UPDATE_PIPELINE_DOC_REQUEST = 'UPDATE_PIPELINE_DOC_REQUEST';
export const UPDATE_PIPELINE_DOC_SUCCESS = 'UPDATE_PIPELINE_DOC_SUCCESS';
export const UPDATE_PIPELINE_DOC_FAILURE = 'UPDATE_PIPELINE_DOC_FAILURE';

export const UPDATE_PIPELINE_INFO_REQUEST = 'UPDATE_PIPELINE_INFO_REQUEST';
export const UPDATE_PIPELINE_INFO_SUCCESS = 'UPDATE_PIPELINE_INFO_SUCCESS';
export const UPDATE_PIPELINE_INFO_FAILURE = 'UPDATE_PIPELINE_INFO_FAILURE';

export const GET_PROJECTS_REQUEST = 'GET_PROJECTS_REQUEST';
export const GET_PROJECTS_SUCCESS = 'GET_PROJECTS_SUCCESS';
export const GET_PROJECTS_FAILURE = 'GET_PROJECTS_FAILURE';

// Single Project
export const GET_PROJECT_REQUEST = 'GET_PROJECT_REQUEST';
export const GET_PROJECT_SUCCESS = 'GET_PROJECT_SUCCESS';
export const GET_PROJECT_FAILURE = 'GET_PROJECT_FAILURE';

export const SEARCH_PROJECTS_REQUEST = 'SEARCH_PROJECTS_REQUEST';
export const SEARCH_PROJECTS_SUCCESS = 'SEARCH_PROJECTS_SUCCESS';
export const SEARCH_PROJECTS_FAILURE = 'SEARCH_PROJECTS_FAILURE';

export const DELETE_PROJECTS_REQUEST = 'DELETE_PROJECTS_REQUEST';
export const DELETE_PROJECTS_SUCCESS = 'DELETE_PROJECTS_SUCCESS';
export const DELETE_PROJECTS_FAILURE = 'DELETE_PROJECTS_FAILURE';

export const ASSIGN_FLOW_TO_PROJECT_REQUEST = 'ASSIGN_FLOW_TO_PROJECT_REQUEST';
export const ASSIGN_FLOW_TO_PROJECT_SUCCESS = 'ASSIGN_FLOW_TO_PROJECT_SUCCESS';
export const ASSIGN_FLOW_TO_PROJECT_FAILURE = 'ASSIGN_FLOW_TO_PROJECT_FAILURE';

export const ASSIGN_FLOWS_TO_PROJECT_REQUEST = 'ASSIGN_FLOWS_TO_PROJECT_REQUEST';
export const ASSIGN_FLOWS_TO_PROJECT_SUCCESS = 'ASSIGN_FLOWS_TO_PROJECT_SUCCESS';
export const ASSIGN_FLOWS_TO_PROJECT_FAILURE = 'ASSIGN_FLOWS_TO_PROJECT_FAILURE';

export const SET_SELECTED_PROJECT_FLOW = 'SET_SELECTED_PROJECT_FLOW';
export const CLEAR_SELECTED_PROJECT_FLOW = 'CLEAR_SELECTED_PROJECT_FLOW';

export const CREATE_PROJECT_ASSIGN_FLOW_REQUEST = 'CREATE_PROJECT_ASSIGN_FLOW_REQUEST';
export const CREATE_PROJECT_ASSIGN_FLOW_SUCCESS = 'CREATE_PROJECT_ASSIGN_FLOW_SUCCESS';
export const CREATE_PROJECT_ASSIGN_FLOW_FAILURE = 'CREATE_PROJECT_ASSIGN_FLOW_FAILURE';

export const UPDATE_PROJECT_METAINFO_REQUEST = 'UPDATE_PROJECT_METAINFO_REQUEST';
export const UPDATE_PROJECT_METAINFO_SUCCESS = 'UPDATE_PROJECT_METAINFO_SUCCESS';
export const UPDATE_PROJECT_METAINFO_FAILURE = 'UPDATE_PROJECT_METAINFO_FAILURE';

export const UPDATE_PROJECT_DOCUMENTATION_REQUEST = 'UPDATE_PROJECT_DOCUMENTATION_REQUEST';
export const UPDATE_PROJECT_DOCUMENTATION_SUCCESS = 'UPDATE_PROJECT_DOCUMENTATION_SUCCESS';
export const UPDATE_PROJECT_DOCUMENTATION_FAILURE = 'UPDATE_PROJECT_DOCUMENTATION_FAILURE';

// Get Project Doc
export const GET_PROJECT_DOCUMENTATION_REQUEST = 'GET_PROJECT_DOCUMENTATION_REQUEST';
export const GET_PROJECT_DOCUMENTATION_SUCCESS = 'GET_PROJECT_DOCUMENTATION_SUCCESS';
export const GET_PROJECT_DOCUMENTATION_FAILURE = 'GET_PROJECT_DOCUMENTATION_FAILURE';

export const REMOVE_FLOW_FROM_PROJECT_REQUEST = 'REMOVE_FLOW_FROM_PROJECT_REQUEST';
export const REMOVE_FLOW_FROM_PROJECT_SUCCESS = 'REMOVE_FLOW_FROM_PROJECT_SUCCESS';
export const REMOVE_FLOW_FROM_PROJECT_FAILURE = 'REMOVE_FLOW_FROM_PROJECT_FAILURE';

// Current Project Management
export const SET_CURRENT_PROJECT_ID = 'SET_CURRENT_PROJECT_ID';
export const CLEAR_CURRENT_PROJECT_ID = 'CLEAR_CURRENT_PROJECT_ID';

export const CLONE_FLOW_REQUEST = 'CLONE_FLOW_REQUEST';
export const CLONE_FLOW_SUCCESS = 'CLONE_FLOW_SUCCESS';
export const CLONE_FLOW_FAILURE = 'CLONE_FLOW_FAILURE';

export const CREATE_RAG_FLOW_REQUEST = 'CREATE_RAG_FLOW_REQUEST';
export const CREATE_RAG_FLOW_SUCCESS = 'CREATE_RAG_FLOW_SUCCESS';
export const CREATE_RAG_FLOW_FAILURE = 'CREATE_RAG_FLOW_FAILURE';

export const CREATE_API_SERVER_FLOW_REQUEST = 'CREATE_API_SERVER_FLOW_REQUEST';
export const CREATE_API_SERVER_FLOW_SUCCESS = 'CREATE_API_SERVER_FLOW_SUCCESS';
export const CREATE_API_SERVER_FLOW_FAILURE = 'CREATE_API_SERVER_FLOW_FAILURE';

export const QUERY_RAG_FLOW_REQUEST = 'QUERY_RAG_FLOW_REQUEST';
export const QUERY_RAG_FLOW_SUCCESS = 'QUERY_RAG_FLOW_SUCCESS';
export const QUERY_RAG_FLOW_FAILURE = 'QUERY_RAG_FLOW_FAILURE';

export const UPDATE_CACHE_RAG_FLOW_REQUEST = 'UPDATE_CACHE_RAG_FLOW_REQUEST';
export const UPDATE_CACHE_RAG_FLOW_SUCCESS = 'UPDATE_CACHE_RAG_FLOW_SUCCESS';
export const UPDATE_CACHE_RAG_FLOW_FAILURE = 'UPDATE_CACHE_RAG_FLOW_FAILURE';

export const PUBLISH_RAG_FLOW_REQUEST = 'PUBLISH_RAG_FLOW_REQUEST';
export const PUBLISH_RAG_FLOW_SUCCESS = 'PUBLISH_RAG_FLOW_SUCCESS';
export const PUBLISH_RAG_FLOW_FAILURE = 'PUBLISH_RAG_FLOW_FAILURE';

export const GET_FLOW_METRICS_REQUEST = 'GET_FLOW_METRICS_REQUEST';
export const GET_FLOW_METRICS_SUCCESS = 'GET_FLOW_METRICS_SUCCESS';
export const GET_FLOW_METRICS_FAILURE = 'GET_FLOW_METRICS_FAILURE';

export const GET_FLOW_RUNS_REQUEST = 'GET_FLOW_RUNS_REQUEST';
export const GET_FLOW_RUNS_SUCCESS = 'GET_FLOW_RUNS_SUCCESS';
export const GET_FLOW_RUNS_FAILURE = 'GET_FLOW_RUNS_FAILURE';

export const CLEAR_FLOW_RUNS = 'CLEAR_FLOW_RUNS';

export const GET_FLOW_RUN_SUMMARY_REQUEST = 'GET_FLOW_RUN_SUMMARY_REQUEST';
export const GET_FLOW_RUN_SUMMARY_SUCCESS = 'GET_FLOW_RUN_SUMMARY_SUCCESS';
export const GET_FLOW_RUN_SUMMARY_FAILURE = 'GET_FLOW_RUN_SUMMARY_FAILURE';

export const CLEAR_FLOW_RUN_SUMMARY = 'CLEAR_FLOW_RUN_SUMMARY';

export const SET_FLOW_METRICS_INTERVAL = 'SET_FLOW_METRICS_INTERVAL';

export const GET_FLOW_RUN_LOGS_REQUEST = 'GET_FLOW_RUN_LOGS_REQUEST';
export const GET_FLOW_RUN_LOGS_SUCCESS = 'GET_FLOW_RUN_LOGS_SUCCESS';
export const GET_FLOW_RUN_LOGS_FAILURE = 'GET_FLOW_RUN_LOGS_FAILURE';

export const GET_FLOW_RUN_LOGS_WITH_FACETS_REQUEST_V2 = 'GET_FLOW_RUN_LOGS_WITH_FACETS_REQUEST_V2';
export const GET_FLOW_RUN_LOGS_WITH_FACETS_SUCCESS_V2 = 'GET_FLOW_RUN_LOGS_WITH_FACETS_SUCCESS_V2';
export const GET_FLOW_RUN_LOGS_WITH_FACETS_FAILURE_V2 = 'GET_FLOW_RUN_LOGS_WITH_FACETS_FAILURE_V2';
export const GET_FLOW_RUN_LOGS_WITH_FACETS_AUTO_REFRESH_REQUEST_V2 =
  'GET_FLOW_RUN_LOGS_WITH_FACETS_AUTO_REFRESH_REQUEST_V2';
export const GET_FLOW_RUN_LOGS_WITH_FACETS_AUTO_REFRESH_SUCCESS_V2 =
  'GET_FLOW_RUN_LOGS_WITH_FACETS_AUTO_REFRESH_SUCCESS_V2';
export const GET_FLOW_RUN_LOGS_WITH_FACETS_AUTO_REFRESH_FAILURE_V2 =
  'GET_FLOW_RUN_LOGS_WITH_FACETS_AUTO_REFRESH_FAILURE_V2';
export const CLEAR_FLOW_RUN_LOGS_WITH_FACETS_V2 = 'CLEAR_FLOW_RUN_LOGS_WITH_FACETS_V2';

export const GET_FLOW_RUN_LOGS_METADATA_REQUEST = 'GET_FLOW_RUN_LOGS_METADATA_REQUEST';
export const GET_FLOW_RUN_LOGS_METADATA_SUCCESS = 'GET_FLOW_RUN_LOGS_METADATA_SUCCESS';
export const GET_FLOW_RUN_LOGS_METADATA_FAILURE = 'GET_FLOW_RUN_LOGS_METADATA_FAILURE';

export const CLEAR_FLOW_RUN_LOGS = 'CLEAR_FLOW_RUN_LOGS';

export const SET_RAG_QUERY = 'SET_RAG_QUERY';
export const SET_RAG_NODE_FORM_DATA = 'SET_RAG_NODE_FORM_DATA';
export const RESET_RAG = 'RESET_RAG';

export const GET_CATALOG_CONFIGS_REQUEST = 'GET_CATALOG_CONFIGS_REQUEST';
export const GET_CATALOG_CONFIGS_SUCCESS = 'GET_CATALOG_CONFIGS_SUCCESS';
export const GET_CATALOG_CONFIGS_FAILURE = 'GET_CATALOG_CONFIGS_FAILURE';

export const ADD_CATALOG_CONFIG_REQUEST = 'ADD_CATALOG_CONFIG_REQUEST';
export const ADD_CATALOG_CONFIG_SUCCESS = 'ADD_CATALOG_CONFIG_SUCCESS';
export const ADD_CATALOG_CONFIG_FAILURE = 'ADD_CATALOG_CONFIG_FAILURE';

export const UPDATE_CATALOG_CONFIG_REQUEST = 'UPDATE_CATALOG_CONFIG_REQUEST';
export const UPDATE_CATALOG_CONFIG_SUCCESS = 'UPDATE_CATALOG_CONFIG_SUCCESS';
export const UPDATE_CATALOG_CONFIG_FAILURE = 'UPDATE_CATALOG_CONFIG_FAILURE';

export const GET_GEN_AI_CONFIGS_REQUEST = 'GET_GEN_AI_CONFIGS_REQUEST';
export const GET_GEN_AI_CONFIGS_SUCCESS = 'GET_GEN_AI_CONFIGS_SUCCESS';
export const GET_GEN_AI_CONFIGS_FAILURE = 'GET_GEN_AI_CONFIGS_FAILURE';

export const ADD_GEN_AI_CONFIG_REQUEST = 'ADD_GEN_AI_CONFIG_REQUEST';
export const ADD_GEN_AI_CONFIG_SUCCESS = 'ADD_GEN_AI_CONFIG_SUCCESS';
export const ADD_GEN_AI_CONFIG_FAILURE = 'ADD_GEN_AI_CONFIG_FAILURE';

export const UPDATE_GEN_AI_CONFIG_REQUEST = 'UPDATE_GEN_AI_CONFIG_REQUEST';
export const UPDATE_GEN_AI_CONFIG_SUCCESS = 'UPDATE_GEN_AI_CONFIG_SUCCESS';
export const UPDATE_GEN_AI_CONFIG_FAILURE = 'UPDATE_GEN_AI_CONFIG_FAILURE';

export const DOC_RECOMMENDATION_REQUEST = 'DOC_RECOMMENDATION_REQUEST';
export const DOC_RECOMMENDATION_SUCCESS = 'DOC_RECOMMENDATION_SUCCESS';
export const DOC_RECOMMENDATION_FAILURE = 'DOC_RECOMMENDATION_FAILURE';

export const CLEAR_DOC_RECOMMENDATION = 'CLEAR_DOC_RECOMMENDATION';

export const NEX_ORG_SWITCH_REQUEST = 'NEX_ORG_SWITCH_REQUEST';
export const NEX_ORG_SWITCH_SUCCESS = 'NEX_ORG_SWITCH_SUCCESS';
export const NEX_ORG_SWITCH_FAILURE = 'NEX_ORG_SWITCH_FAILURE';

export const SAVE_HASHED_STATE = 'SAVE_HASHED_STATE';
export const HYDRATE_HASHED_STATE = 'HYDRATE_HASHED_STATE';

/**
 * @ServiceKeys
 */
export const GET_ALL_SERVICE_KEYS_REQUEST = 'GET_ALL_SERVICE_KEYS_REQUEST';
export const GET_ALL_SERVICE_KEYS_SUCCESS = 'GET_ALL_SERVICE_KEYS_SUCCESS';
export const GET_ALL_SERVICE_KEYS_FAILURE = 'GET_ALL_SERVICE_KEYS_FAILURE';
export const UPDATE_SERVICE_KEYS_REQUEST = 'UPDATE_SERVICE_KEY_REQUEST';
export const UPDATE_SERVICE_KEYS_SUCCESS = 'UPDATE_SERVICE_KEY_SUCCESS';
export const UPDATE_SERVICE_KEYS_FAILURE = 'UPDATE_SERVICE_KEY_FAILURE';
export const DELETE_SERVICE_KEY_REQUEST = 'DELETE_SERVICE_KEY_REQUEST';
export const DELETE_SERVICE_KEY_SUCCESS = 'DELETE_SERVICE_KEY_SUCCESS';
export const DELETE_SERVICE_KEY_FAILURE = 'DELETE_SERVICE_KEY_FAILURE';
export const CREATE_SERVICE_KEY_REQUEST = 'CREATE_SERVICE_KEY_REQUEST';
export const CREATE_SERVICE_KEY_SUCCESS = 'CREATE_SERVICE_KEY_SUCCESS';
export const CREATE_SERVICE_KEY_FAILURE = 'CREATE_SERVICE_KEY_FAILURE';
export const ROTATE_SERVICE_KEY_REQUEST = 'ROTATE_SERVICE_KEY_REQUEST';
export const ROTATE_SERVICE_KEY_SUCCESS = 'ROTATE_SERVICE_KEY_SUCCESS';
export const ROTATE_SERVICE_KEY_FAILURE = 'ROTATE_SERVICE_KEY_FAILURE';
export const PAUSE_SERVICE_KEY_REQUEST = 'PAUSE_SERVICE_KEY_REQUEST';
export const PAUSE_SERVICE_KEY_SUCCESS = 'PAUSE_SERVICE_KEY_SUCCESS';
export const PAUSE_SERVICE_KEY_FAILURE = 'PAUSE_SERVICE_KEY_FAILURE';
export const ACTIVATE_SERVICE_KEY_REQUEST = 'ACTIVATE_API_KEY_REQUEST';
export const ACTIVATE_SERVICE_KEY_SUCCESS = 'ACTIVATE_API_KEY_SUCCESS';
export const ACTIVATE_SERVICE_KEY_FAILURE = 'ACTIVATE_API_KEY_FAILURE';

/**
 * @SdkApplications
 */
export const GET_ALL_SDK_APPLICATIONS_REQUEST = 'GET_ALL_SDK_APPLICATIONS_REQUEST';
export const GET_ALL_SDK_APPLICATIONS_SUCCESS = 'GET_ALL_SDK_APPLICATIONS_SUCCESS';
export const GET_ALL_SDK_APPLICATIONS_FAILURE = 'GET_ALL_SDK_APPLICATIONS_FAILURE';
export const CREATE_SDK_APPLICATION_REQUEST = 'CREATE_SDK_APPLICATION_REQUEST';
export const CREATE_SDK_APPLICATION_SUCCESS = 'CREATE_SDK_APPLICATION_SUCCESS';
export const CREATE_SDK_APPLICATION_FAILURE = 'CREATE_SDK_APPLICATION_FAILURE';
export const UPDATE_SDK_APPLICATION_REQUEST = 'UPDATE_SDK_APPLICATION_REQUEST';
export const UPDATE_SDK_APPLICATION_SUCCESS = 'UPDATE_SDK_APPLICATION_SUCCESS';
export const UPDATE_SDK_APPLICATION_FAILURE = 'UPDATE_SDK_APPLICATION_FAILURE';
export const DELETE_SDK_APPLICATION_REQUEST = 'DELETE_SDK_APPLICATION_REQUEST';
export const DELETE_SDK_APPLICATION_SUCCESS = 'DELETE_SDK_APPLICATION_SUCCESS';
export const DELETE_SDK_APPLICATION_FAILURE = 'DELETE_SDK_APPLICATION_FAILURE';
export const PAUSE_SDK_APPLICATION_REQUEST = 'PAUSE_SDK_APPLICATION_REQUEST';
export const PAUSE_SDK_APPLICATION_SUCCESS = 'PAUSE_SDK_APPLICATION_SUCCESS';
export const PAUSE_SDK_APPLICATION_FAILURE = 'PAUSE_SDK_APPLICATION_FAILURE';
export const ACTIVATE_SDK_APPLICATION_REQUEST = 'ACTIVATE_SDK_APPLICATION_REQUEST';
export const ACTIVATE_SDK_APPLICATION_SUCCESS = 'ACTIVATE_SDK_APPLICATION_SUCCESS';
export const ACTIVATE_SDK_APPLICATION_FAILURE = 'ACTIVATE_SDK_APPLICATION_FAILURE';
export const GET_SDK_APPLICATION_REQUEST = 'GET_SDK_APPLICATION_REQUEST';
export const GET_SDK_APPLICATION_SUCCESS = 'GET_SDK_APPLICATION_SUCCESS';
export const GET_SDK_APPLICATION_FAILURE = 'GET_SDK_APPLICATION_FAILURE';

export const UPDATE_DESTINATION_DRAFT = 'UPDATE_DESTINATION_DRAFT';

export const UPDATE_NEXSET_SAMPLE_DRAFT = 'UPDATE_NEXSET_SAMPLE_DRAFT';
export const CLEAR_NEXSET_SAMPLE_DRAFT = 'CLEAR_NEXSET_SAMPLE_DRAFT';
export const ACCUMULATE_SCHEMA_FOR_NEXSET_SAMPLE = 'ACCUMULATE_SCHEMA_FOR_NEXSET_SAMPLE';

export const ACCUMULATE_SCHEMA = 'ACCUMULATE_SCHEMA';
export const ACCUMULATE_SCHEMA_REQUEST = 'ACCUMULATE_SCHEMA_REQUEST';
export const ACCUMULATE_SCHEMA_SUCCESS = 'ACCUMULATE_SCHEMA_SUCCESS';
export const ACCUMULATE_SCHEMA_FAILURE = 'ACCUMULATE_SCHEMA_FAILURE';

export const GENERATE_SEMANTIC_SCHEMA_REQUEST = 'GENERATE_SEMANTIC_SCHEMA_REQUEST';
export const GENERATE_SEMANTIC_SCHEMA_SUCCESS = 'GENERATE_SEMANTIC_SCHEMA_SUCCESS';
export const GENERATE_SEMANTIC_SCHEMA_FAILURE = 'GENERATE_SEMANTIC_SCHEMA_FAILURE';

// Flow triggers
export const DELETE_FLOW_TRIGGERS_REQUEST = 'DELETE_FLOW_TRIGGERS_REQUEST';
export const DELETE_FLOW_TRIGGERS_SUCCESS = 'DELETE_FLOW_TRIGGERS_SUCCESS';
export const DELETE_FLOW_TRIGGERS_FAILURE = 'DELETE_FLOW_TRIGGERS_FAILURE';

export const LOAD_FLOW_TRIGGERS_REQUEST = 'LOAD_FLOW_TRIGGERS_REQUEST';
export const LOAD_FLOW_TRIGGERS_SUCCESS = 'LOAD_FLOW_TRIGGERS_SUCCESS';
export const LOAD_FLOW_TRIGGERS_FAILURE = 'LOAD_FLOW_TRIGGERS_FAILURE';

export const CREATE_FLOW_TRIGGERS_REQUEST = 'CREATE_FLOW_TRIGGERS_REQUEST';
export const CREATE_FLOW_TRIGGERS_SUCCESS = 'CREATE_FLOW_TRIGGERS_SUCCESS';
export const CREATE_FLOW_TRIGGERS_FAILURE = 'CREATE_FLOW_TRIGGERS_FAILURE';

// Marketplace
export const GET_ALL_DOMAINS_REQUEST = 'GET_ALL_DOMAINS_REQUEST';
export const GET_ALL_DOMAINS_SUCCESS = 'GET_ALL_DOMAINS_SUCCESS';
export const GET_ALL_DOMAINS_FAILURE = 'GET_ALL_DOMAINS_FAILURE';
export const GET_DOMAIN_ITEMS_REQUEST = 'GET_DOMAIN_ITEMS_REQUEST';
export const GET_DOMAIN_ITEMS_SUCCESS = 'GET_DOMAIN_ITEMS_SUCCESS';
export const GET_DOMAIN_ITEMS_FAILURE = 'GET_DOMAIN_ITEMS_FAILURE';
export const GET_DOMAIN_ITEM_REQUEST = 'GET_DOMAIN_ITEM_REQUEST';
export const GET_DOMAIN_ITEM_SUCCESS = 'GET_DOMAIN_ITEM_SUCCESS';
export const GET_DOMAIN_ITEM_FAILURE = 'GET_DOMAIN_ITEM_FAILURE';
export const UPDATE_DOMAIN_ITEM_ACCESS_REQUEST = 'UPDATE_DOMAIN_ITEM_ACCESS_REQUEST';
export const UPDATE_DOMAIN_ITEM_ACCESS_SUCCESS = 'UPDATE_DOMAIN_ITEM_ACCESS_SUCCESS';
export const UPDATE_DOMAIN_ITEM_ACCESS_FAILURE = 'UPDATE_DOMAIN_ITEM_ACCESS_FAILURE';
export const ADD_DOMAIN_ITEM_REQUEST = 'ADD_DOMAIN_ITEM_REQUEST';
export const ADD_DOMAIN_ITEM_SUCCESS = 'ADD_DOMAIN_ITEM_SUCCESS';
export const ADD_DOMAIN_ITEM_FAILURE = 'ADD_DOMAIN_ITEM_FAILURE';
export const DELETE_DOMAIN_ITEM_REQUEST = 'DELETE_DOMAIN_ITEM_REQUEST';
export const DELETE_DOMAIN_ITEM_SUCCESS = 'DELETE_DOMAIN_ITEM_SUCCESS';
export const DELETE_DOMAIN_ITEM_FAILURE = 'DELETE_DOMAIN_ITEM_FAILURE';
export const GET_OUTGOING_ACCESS_REQUESTS_REQUEST = 'GET_OUTGOING_ACCESS_REQUESTS_REQUEST';
export const GET_OUTGOING_ACCESS_REQUESTS_SUCCESS = 'GET_OUTGOING_ACCESS_REQUESTS_SUCCESS';
export const GET_OUTGOING_ACCESS_REQUESTS_FAILURE = 'GET_OUTGOING_ACCESS_REQUESTS_FAILURE';
export const GET_INCOMING_ACCESS_REQUESTS_REQUEST = 'GET_INCOMING_ACCESS_REQUESTS_REQUEST';
export const GET_INCOMING_ACCESS_REQUESTS_SUCCESS = 'GET_INCOMING_ACCESS_REQUESTS_SUCCESS';
export const GET_INCOMING_ACCESS_REQUESTS_FAILURE = 'GET_INCOMING_ACCESS_REQUESTS_FAILURE';
export const GET_OUTGOING_LISTING_REQUESTS_REQUEST = 'GET_OUTGOING_LISTING_REQUESTS_REQUEST';
export const GET_OUTGOING_LISTING_REQUESTS_SUCCESS = 'GET_OUTGOING_LISTING_REQUESTS_SUCCESS';
export const GET_OUTGOING_LISTING_REQUESTS_FAILURE = 'GET_OUTGOING_LISTING_REQUESTS_FAILURE';
export const GET_INCOMING_LISTING_REQUESTS_REQUEST = 'GET_INCOMING_LISTING_REQUESTS_REQUEST';
export const GET_INCOMING_LISTING_REQUESTS_SUCCESS = 'GET_INCOMING_LISTING_REQUESTS_SUCCESS';
export const GET_INCOMING_LISTING_REQUESTS_FAILURE = 'GET_INCOMING_LISTING_REQUESTS_FAILURE';
export const GET_REQUEST_DATASET_REQUEST = 'GET_REQUEST_DATASET_REQUEST';
export const GET_REQUEST_DATASET_SUCCESS = 'GET_REQUEST_DATASET_SUCCESS';
export const GET_REQUEST_DATASET_FAILURE = 'GET_REQUEST_DATASET_FAILURE';
export const ADD_DOMAIN_ITEM_RATING_REQUEST = 'ADD_DOMAIN_ITEM_RATING_REQUEST';
export const ADD_DOMAIN_ITEM_RATING_SUCCESS = 'ADD_DOMAIN_ITEM_RATING_SUCCESS';
export const ADD_DOMAIN_ITEM_RATING_FAILURE = 'ADD_DOMAIN_ITEM_RATING_FAILURE';
export const APPROVE_MARKETPLACE_REQUEST_REQUEST = 'APPROVE_MARKETPLACE_REQUEST_REQUEST';
export const APPROVE_MARKETPLACE_REQUEST_SUCCESS = 'APPROVE_MARKETPLACE_REQUEST_SUCCESS';
export const APPROVE_MARKETPLACE_REQUEST_FAILURE = 'APPROVE_MARKETPLACE_REQUEST_FAILURE';
export const REJECT_MARKETPLACE_REQUEST_REQUEST = 'REJECT_MARKETPLACE_REQUEST_REQUEST';
export const REJECT_MARKETPLACE_REQUEST_SUCCESS = 'REJECT_MARKETPLACE_REQUEST_SUCCESS';
export const REJECT_MARKETPLACE_REQUEST_FAILURE = 'REJECT_MARKETPLACE_REQUEST_FAILURE';
export const ADD_DOMAIN_REQUEST = 'ADD_DOMAIN_REQUEST';
export const ADD_DOMAIN_SUCCESS = 'ADD_DOMAIN_SUCCESS';
export const ADD_DOMAIN_FAILURE = 'ADD_DOMAIN_FAILURE';
export const DELETE_DOMAIN_REQUEST = 'DELETE_DOMAIN_REQUEST';
export const DELETE_DOMAIN_SUCCESS = 'DELETE_DOMAIN_SUCCESS';
export const DELETE_DOMAIN_FAILURE = 'DELETE_DOMAIN_FAILURE';
export const UPDATED_DOMAIN_INFO_REQUEST = 'UPDATED_DOMAIN_INFO_REQUEST';
export const UPDATED_DOMAIN_INFO_SUCCESS = 'UPDATED_DOMAIN_INFO_SUCCESS';
export const UPDATED_DOMAIN_INFO_FAILURE = 'UPDATED_DOMAIN_INFO_FAILURE';
export const GET_DOMAIN_CUSTODIANS_REQUEST = 'GET_DOMAIN_CUSTODIANS_REQUEST';
export const GET_DOMAIN_CUSTODIANS_SUCCESS = 'GET_DOMAIN_CUSTODIANS_SUCCESS';
export const GET_DOMAIN_CUSTODIANS_FAILURE = 'GET_DOMAIN_CUSTODIANS_FAILURE';
export const DELETE_DOMAIN_CUSTODIAN_REQUEST = 'DELETE_DOMAIN_CUSTODIAN_REQUEST';
export const DELETE_DOMAIN_CUSTODIAN_SUCCESS = 'DELETE_DOMAIN_CUSTODIAN_SUCCESS';
export const DELETE_DOMAIN_CUSTODIAN_FAILURE = 'DELETE_DOMAIN_CUSTODIAN_FAILURE';
export const ADD_DOMAIN_CUSTODIAN_REQUEST = 'ADD_DOMAIN_CUSTODIAN_REQUEST';
export const ADD_DOMAIN_CUSTODIAN_SUCCESS = 'ADD_DOMAIN_CUSTODIAN_SUCCESS';
export const ADD_DOMAIN_CUSTODIAN_FAILURE = 'ADD_DOMAIN_CUSTODIAN_FAILURE';
export const UPDATE_MARKETPLACE_ITEM = 'UPDATE_MARKETPLACE_ITEM';

// API Server Actions
export const CREATE_API_REQUEST_REQUEST = 'CREATE_API_REQUEST_REQUEST';
export const CREATE_API_REQUEST_SUCCESS = 'CREATE_API_REQUEST_SUCCESS';
export const CREATE_API_REQUEST_FAILURE = 'CREATE_API_REQUEST_FAILURE';

// Flow Control
export const RUN_FLOW_NOW_REQUEST = 'RUN_FLOW_NOW_REQUEST';
export const RUN_FLOW_NOW_SUCCESS = 'RUN_FLOW_NOW_SUCCESS';
export const RUN_FLOW_NOW_FAILURE = 'RUN_FLOW_NOW_FAILURE';

// splitter
export const SPLITTER_SET_MODE = 'SPLITTER_SET_MODE';
export const SPLITTER_SET_FALLBACK = 'SPLITTER_SET_FALLBACK';
export const SPLITTER_SET_EXPRESSIONS = 'SPLITTER_SET_EXPRESSIONS';
export const SPLITTER_SET_ATTR = 'SPLITTER_SET_ATTR';
export const SPLITTER_SET_VALUES = 'SPLITTER_SET_VALUES';
export const SPLITTER_SET_LOADING = 'SPLITTER_SET_LOADING';
export const SPLITTER_SET_LAST_TX_PAYLOAD = 'SPLITTER_SET_LAST_TX_PAYLOAD';
export const SPLITTER_RESET = 'SPLITTER_RESET';

// Intent
export const CREATE_EARLY_INTENT_REQUEST = 'CREATE_EARLY_INTENT_REQUEST';
export const CREATE_EARLY_INTENT_SUCCESS = 'CREATE_EARLY_INTENT_SUCCESS';
export const CREATE_EARLY_INTENT_FAILURE = 'CREATE_EARLY_INTENT_FAILURE';

export const VALIDATE_SESSION_REQUEST = 'VALIDATE_SESSION_REQUEST';
export const VALIDATE_SESSION_SUCCESS = 'VALIDATE_SESSION_SUCCESS';
export const VALIDATE_SESSION_FAILURE = 'VALIDATE_SESSION_FAILURE';

export * from './aiActionTypes';
